<!-- 업무보드 내용 (상단부 & 탭 [편집기,할 일,파일]) -->
<template>
  <section
    class="board-content"
    :class="
      (paperInfo.permission < 2 ? ' readonly' : '') +
      (paperInfo.mounted && paperInfo.permission > 0 ? '' : ' hidden')
    "
    :style="dBHeight"
  >
    <!-- [모달창 (파일업로드 등)] -->
    <modals-container
      @submit="onSubmit"
      @setUploadData="setUploadData"
      @fileUpload="fileUpload"
      @closeBoardLeftModal="closeBoardLeftModal"
      @dialogConfirm="dialogConfirm"
      @closeBoardLinkProjectModal="closeBoardLinkProjectModal"
      @closeBoardOkrLinkPopup="closeBoardOkrLinkPopup"
      @updateTodoList="updateTodoList"
    >
    </modals-container>
    <!-- [업무보드 컨텐츠 > 상단부 영역] -->
    <div
      id="boardHeader"
      class="board-header"
      :class="{ fixed: isFixed }"
      v-if="boardSection[0] != 'SNAPSHOT'"
    >
      <div class="left">
        <button
          type="button"
          class="btn_back permit_everyone"
          @click="goPrevPage"
        >
          {{$i18nUtil.trans("button.back","뒤로가기")}}
        </button>
        <ul class="board-menu">
          <li
            v-for="(tab, index) in tabs"
            v-bind:class="{ active: currentTab === index }"
            :key="index"
          >
            <button
              type="button"
              class="permit_everyone"
              @click="changeTab(index)"
            >
              {{ tab }}
            </button>
          </li>
        </ul>
      </div>
      <input type="hidden" id="isWindowPop" />
      <div class="right">
        <!-- 2020-12-11 기능 개발 전으로 안나오도록 처리. -->
        <!-- <div class="dropdown-list-item division" v-if="boardSection[0] == null || boardSection[0] == 'PRIV'"> -->
        <!-- 2021-03-04 okr사용여부 조회 추가 false(TODO임시: 오픈시 나오지 않게 하기 위해 추가) -->
        <button type="button" class="btn-primary-smaller black"
          v-if="okrUseFlag &&
                isInternalUser &&
                (boardSection[0] == null || boardSection[0] == 'PRIV') &&
                paperInfo.permission > 1 &&
                tenantId !== '418502' && tenantId !== '201' && tenantId !== '203'"
          @click="reqFeedbackModal()">
          {{$i18nUtil.trans("button.reqFeedback", "피드백 요청하기")}}
        </button>
        <!-- 2020-12-24 스테이징 오픈 기준 숨김 -->
        <!-- <button
          type="button"
          class="link-okr"
          v-if="
            paperInfo.internalUserYn == true &&
            (boardSection[0] == null || boardSection[0] == 'PRIV')
          "
        >
          <span>OKR 0</span>
        </button> -->
        <!-- 2021-03-04 okr사용여부 조회 추가 false(TODO임시: 오픈시 나오지 않게 하기 위해 추가) -->
        <div class="dropdown right ty3 okr" v-if="okrUseFlag && isInternalUser && tenantId !== '201' && tenantId !== '203'">
          <v-menu bottom left :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="link-okr permit_everyone"
                @click="getBoardKrQrtList"
                >OKR {{ paperKrLinkCount }}</v-btn
              >
            </template>
            <div>
              <div class="top clear">
                <div
                  class="dropdown ty2 relative fl"
                  v-if="qrtList != null && qrtList.length > 0"
                >
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on">{{
                        $i18nUtil.getLanguage() !== 'ko' && currentQrt.qrtTopMsgEn != null ? currentQrt.qrtTopMsgEn : currentQrt.qrtTopMsg
                      }}</v-btn>
                    </template>
                    <div class="dropdown-list">
                      <div
                        class="dropdown-list-item"
                        v-for="(qrtItem, qrtIndex) in qrtList"
                        :key="'qrt' + qrtIndex"
                      >
                        <div class="tit">
                          <button
                            type="button"
                            :class="{
                              active: qrtItem.QRT_CD == currentQrt.qrtCd,
                            }"
                            @click="qrtChange(qrtItem.QRT_CD, $event)"
                          >
                            {{ $i18nUtil.getLanguage() !== 'ko' && qrtItem.QRT_TOP_MSG_EN != null ? qrtItem.QRT_TOP_MSG_EN : qrtItem.QRT_TOP_MSG }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </v-menu>
                </div>
                <button
                  type="button"
                  class="btn_link_add fr"
                  v-if="paperInfo.permission > 1"
                  @click="linkedOkrPopup"
                >
                  {{ tenantId == "418502" ? $i18nUtil.trans('message.BoardContents.002','Work 연결 추가') : $i18nUtil.trans('message.BoardContents.003','KR 연결 추가')}}
                </button>
              </div>
              <div
                class="nodata"
                v-if="paperKrLinkList != null && paperKrLinkList.length == 0"
              >
                {{
                  tenantId == "418502"
                    ? $i18nUtil.trans('message.BoardContents.004','연결된 Work가 없습니다.')
                    : $i18nUtil.trans('message.BoardContents.005','연결된 KR이 없습니다.')
                }}
              </div>
              <div class="scroll" v-else>
                <ul>
                  <li
                    :class="{ disabled: paperKrItem.holdYn == 1 }"
                    v-for="(paperKrItem, paperKrindex) in paperKrLinkList"
                    :key="'Okr' + paperKrindex"
                  >
                    <div class="clear">
                      <div class="fl kr">
                        {{
                          tenantId == "418502"
                            ? "Work"
                            : changeOkrType(paperKrItem.okrType)
                        }}
                      </div>
                      <div class="droplayer tooltipmember relative fl">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on"
                              ><b>{{ $i18nUtil.getLanguage() !== 'ko' && paperKrItem.regUserNameEn != null ? paperKrItem.regUserNameEn : paperKrItem.regUserName }}</b></v-btn
                            >
                          </template>
                          <div class="dropdown-list">
                            <UserTooltip :userId="paperKrItem.regUserId" />
                          </div>
                        </v-menu>
                      </div>
                      <div
                        class="dividing_line_ty3"
                        v-if="paperKrItem.holdYn == 1"
                      ></div>
                      <div
                        class="icon-txt-pause"
                        v-if="paperKrItem.holdYn == 1"
                      >
                        {{$i18nUtil.trans("button.okr.pause","일시정지")}}
                      </div>
                      <button
                        type="button"
                        class="fr unlink"
                        v-if="paperKrItem.regUserId == userInfo.userId"
                        @click="okrDisconnection(paperKrItem.paperOkrLinkId)"
                      >
                        {{$i18nUtil.trans("button.okr.terminateConn","연결 해제")}}
                      </button>
                    </div>
                    <div class="tit">{{ paperKrItem.okrTitle }}</div>
                  </li>
                </ul>
              </div>
            </div>
          </v-menu>
        </div>

        <!-- 2021-01-18 : 기획확인 - 과제 보드의 경우만 링크를 걸 수 있음 -->
        <button
          type="button"
          class="link-task permit_everyone"
          @click="openModal()"
          v-if="boardSection[0] == null && paperInfo.permission == 2"
        >
          {{$i18nUtil.trans("entity.project","과제")}}<!-- {{ projectCount }} -->
        </button>
        <button
          type="button"
          class="link-todo permit_everyone"
          @click="showTodo()"
          v-if="boardSection[0] != 'SHAR' && tenantId != '201'"
        >{{$i18nUtil.trans("entity.todo","할 일")}}</button>
        <span v-if="docGrade == 'SECRET'" class="dropdown right">
          {{
            boardSection[0] != "SHAR"
              ? $i18nUtil.trans("entity.paper.docGrade.SECRET","비공개")
              : paperInfo.categoryInfo.docGrade == "NORMAL"
              ? $i18nUtil.trans("entity.paper.docGrade.NORMAL","전체공개")
              : $i18nUtil.trans("entity.paper.docGrade.SECRET","비공개")
          }}
        </span>
        <div class="dropdown right ty3" v-else>
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="permit_everyone" v-bind="attrs" v-on="on">
                {{
                  docGrade === "NORMAL"
                    ? $i18nUtil.trans("entity.paper.docGrade.NORMAL","전체공개")
                    : docGrade == "RESTRICT"
                    ? $i18nUtil.trans("entity.paper.docGrade.RESTRICT","멤버만 공개")
                    : $i18nUtil.trans("entity.paper.docGrade.SECRET","비공개")
                }}
              </v-btn>
            </template>
            <!-- 과제 보드 공개여부 publicYn == 1 -->
            <div class="dropdown-list" v-if="publicYn == 1">
              <div class="dropdown-list-item">
                <div class="tit">
                  <button
                    type="button"
                    class="permit_everyone"
                    :class="docGrade === 'NORMAL' ? 'active' : ''"
                    @click="changePaperDocGrade('NORMAL')"
                  >
                    {{$i18nUtil.trans("entity.paper.docGrade.NORMAL","전체공개")}}
                  </button>
                </div>
              </div>

              <div class="dropdown-list-item">
                <div class="tit">
                  <button
                    type="button"
                    class="permit_everyone"
                    :class="docGrade === 'RESTRICT' ? 'active' : ''"
                    @click="changePaperDocGrade('RESTRICT')"
                  >
                    {{$i18nUtil.trans("entity.paper.docGrade.RESTRICT","멤버만 공개")}}
                  </button>
                </div>
              </div>

              <div class="dropdown-list-item">
                <div class="tit">
                  <button
                    type="button"
                    class="permit_everyone"
                    :class="docGrade === 'SECRET' ? 'active' : ''"
                    @click="changePaperDocGrade('SECRET')"
                  >
                    {{$i18nUtil.trans("entity.paper.docGrade.SECRET","비공개")}}
                  </button>
                </div>
              </div>
            </div>
            <!-- 과제 보드 공개여부 publicYn == 0 -->
            <div class="dropdown-list" v-if="publicYn == 0">
              <div class="dropdown-list-item">
                <div class="tit">
                  <button
                    type="button"
                    class="permit_everyone"
                    :class="docGrade === 'RESTRICT' ? 'active' : ''"
                    @click="changePaperDocGrade('RESTRICT')"
                  >
                    {{$i18nUtil.trans("entity.paper.docGrade.RESTRICT","멤버만 공개")}}
                  </button>
                </div>
              </div>

              <div class="dropdown-list-item">
                <div class="tit">
                  <button
                    type="button"
                    class="permit_everyone"
                    :class="docGrade === 'SECRET' ? 'active' : ''"
                    @click="changePaperDocGrade('SECRET')"
                  >
                    {{$i18nUtil.trans("entity.paper.docGrade.SECRET","비공개")}}
                  </button>
                </div>
              </div>
            </div>
          </v-menu>
        </div>

        <!-- 멤버는 정보공유 && 전체공개의 경우 보여주지않음. -->
        <div
          class="dropdown ty3 relative right member permit_everyone"
          v-if="
            !(
              boardSection[0] == 'SHAR' &&
              paperInfo.categoryInfo.docGrade == 'NORMAL' &&
              docGrade == 'SECRET'
            )
          "
        >
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="permit_everyone"
                v-bind="attrs"
                v-on="on"
                @click="searchReset"
                ><b>{{$i18nUtil.trans("message.BoardContents.006","멤버")}} {{ paperUserCount }}</b></v-btn
              >
            </template>
            <div class="dropdown-list member-search_box" :class="{'one': inherit == 0 && orgMapUse == 'true'}">
              <form action="" v-if="inherit == 0" onsubmit="return false;">
                <div class="search_ty1">
                  <input
                    type="text"
                    id="searchInput"
                    :disabled="!isInternalUser"
                    :class="{ ico_search: searchMemberInput.length == 0 }"
                    @focus="$event.target.placeholder = ''"
                    @focusout="
                      $event.target.placeholder = $i18nUtil.trans('message.DashboardHeader.001','담당자 이름으로 검색')
                    "
                    :placeholder="$i18nUtil.trans('message.DashboardHeader.001','담당자 이름으로 검색')"
                    autocomplete="off"
                    @keyup.enter="boardMemberSearch($event)"
                    @input="boardMemberSearch($event)"
                    :value="searchMemberInput"
                  />
                  <button
                    type="reset"
                    class="btn_search"
                    @click="clickMemberSearchBtn"
                  >
                    {{$i18nUtil.trans("search.039","검색")}}
                  </button>
                  <div class="member-call-box" v-if="isMemberSearch">
                    <div class="scroll">
                      <div class="nodata" v-if="searchUserList.length == 0">
                        <div class="txt" v-html="$i18nUtil.trans('message.DashBoardHeader.002','해당 검색어와 일치하는<br />사용자가 없습니다.')">
                        </div>
                      </div>
                      <dl v-if="searchUserList.length > 0">
                        <dt>{{$i18nUtil.trans("message.DashBoardHeader.026","멤버 검색 결과")}}</dt>
                        <dd>
                          <div
                            class="nodata"
                            v-if="searchMemberList.length == 0"
                            v-html="$i18nUtil.trans('message.DashBoardHeader.002','해당 검색어와 일치하는<br />사용자가 없습니다.')"
                          >
                          </div>
                          <ul class="member-list" v-else>
                            <li
                              v-for="(item, index) in searchMemberList"
                              :key="'member' + index"
                            >
                              <div
                                class="img user-photo"
                                :data-user-id="item.userId"
                              >
                                <img src="@/assets/img/no-avatar.png" alt="" />
                              </div>
                              <b class="name ell-singleline"
                                >{{ item.userName }}
                                <span>{{ item.positionName }}</span></b
                              >
                              <span class="team ell-singleline"
                                >{{ item.companyName }} /
                                {{
                                  item.isExternalUser
                                    ? item.partnerName
                                    : item.deptName
                                }}</span
                              >
                            </li>
                          </ul>
                        </dd>
                      </dl>
                      <dl v-if="searchUserList.length > 0">
                        <dt v-html="$i18nUtil.trans('message.DashBoardHeader.003','멤버 외 검색 결과 <br />(선택 시 멤버로 자동 추가됩니다.)')">
                        </dt>
                        <dd>
                          <div
                            class="nodata"
                            v-if="searchNoMemberList.length == 0"
                            v-html="$i18nUtil.trans('message.DashBoardHeader.002','해당 검색어와 일치하는<br />사용자가 없습니다.')"
                          >
                          </div>
                          <ul class="member-list" v-else>
                            <li
                              v-for="(item, index) in searchNoMemberList"
                              :key="'noMember' + index"
                              @click="selectBoardUser(item, index)"
                            >
                              <div
                                class="img user-photo"
                                :data-user-id="item.userId"
                              >
                                <img src="@/assets/img/no-avatar.png" alt="" />
                              </div>
                              <b class="name ell-singleline"
                                >{{ item.userName }}
                                <span>{{ item.positionName }}</span></b
                              >
                              <span class="team ell-singleline"
                                >{{ item.companyName }} /
                                {{
                                  item.isExternalUser
                                    ? item.partnerName
                                    : item.deptName
                                }}</span
                              >
                            </li>
                          </ul>
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </form>
              <div class="link_box" v-if="inherit == 0 && orgMapUse == 'true'" style="margin-left: 0px;">
                <button type="button" class="link" style="margin-left: 0px;" @click="onAddPaperUserWithOrg">
                  {{ $i18nUtil.trans("button.member.add.orgChart", "조직도에서 멤버 추가") }}
                </button>
              </div>
              <div class="scroll_box">
                <dl
                  class="my"
                  v-for="(paperUserItem, paperUserIndex) in userList"
                  :key="paperUserIndex"
                  :value="userInfo.userId"
                  v-show="paperUserItem.userId === userInfo.userId"
                >
                  <dt>{{$i18nUtil.trans("message.DashBoardHeader.027","본인")}}</dt>
                  <dd>
                    <ul>
                      <li>
                        
                        <div class="name">
                          {{ paperUserItem.userName }}
                          {{ paperUserItem.jobPositionName }}
                              <!-- 'ico-master':
                                paperUserItem.userGrade == 'MANAGER'
                                  ? paperUserItem.userId != paperInfo.regUserId
                                    ? true
                                    : false
                                  : false, -->
                          <span style = "width : 60px;"
                            :class="{
                              'ico-creat':
                                paperUserItem.userId == paperInfo.regUserId
                                  ? true
                                  : false,
                            }"
                          >
                            {{
                              paperUserItem.userId == paperInfo.regUserId
                                ? $i18nUtil.trans('message.BoardContents.007','보드 생성자')
                                : ""
                            }}
                              <!-- paperUserItem.userId == paperInfo.regUserId
                                ? "생성자"
                                : paperUserItem.userGrade == "MANAGER"
                                ? "운영자"
                                : "" -->
                          </span>
                        </div>
                        <div class="mail">
                          {{
                            paperUserItem.isExternalUser
                              ? paperUserItem.partnerName
                              : paperUserItem.deptName
                          }}
                        </div>
                        <button
                          type="button"
                          class="logout"
                          v-show="inherit == 0 &&  paperUserItem.userId != paperInfo.regUserId"
                          @click="
                            rejectBoardMember(paperUserItem, 'SELF_REJECT')
                          "
                        >
                          {{$i18nUtil.trans("button.exit","나가기")}}
                        </button>
                      </li>
                    </ul>
                  </dd>
                </dl>

                <dl class="colleague">
                  <dt>
                    {{
                      docGrade == "SECRET"
                        ? $i18nUtil.trans('message.BoardContents.008','보드 멤버')
                        : boardSection[0] == null
                        ? $i18nUtil.trans("entity.cogroupUser.groupKbn.pro","과제 멤버")
                        : $i18nUtil.trans('message.BoardContents.009','카테고리 멤버')
                    }}
                    ({{ memberCount(userList.length) }})
                  </dt>
                  <dd>
                    <div
                      class="nodata"
                      v-if="
                        (userList.length == 1 &&
                          userList[0].userId == userInfo.userId) ||
                        userList.length == 0
                      "
                      v-html="$i18nUtil.trans('message.DashBoardHeader.006','멤버를 구성하여<br />협업해보세요.')"
                    >
                    </div>
                    <ul v-else>
                      <li
                        v-for="(paperUserItem, paperUserIndex) in userList"
                        :key="'member' + paperUserIndex"
                      >
                        <div
                          class="droplayer relative"
                          v-if="!(paperUserItem.userId === userInfo.userId)"
                        >
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-bind="attrs" v-on="on" class="name"
                                >{{ paperUserItem.userName }}
                                {{ paperUserItem.jobPositionName }}
                                    <!-- 'ico-master':
                                      paperUserItem.userGrade == 'MANAGER'
                                        ? paperUserItem.userId !=
                                          paperInfo.regUserId
                                          ? true
                                          : false
                                        : false, -->
                                <span
                                style = "width : 60px;"
                                  :class="{
                                    'ico-creat':
                                      paperUserItem.userId ==
                                      paperInfo.regUserId
                                        ? true
                                        : false,
                                  }"
                                >
                                  {{
                                    paperUserItem.userId == paperInfo.regUserId
                                      ? $i18nUtil.trans('message.BoardContents.007','보드 생성자')
                                      : ""
                                  }}
                                    <!-- paperUserItem.userId == paperInfo.regUserId
                                      ? "생성자"
                                      : paperUserItem.userGrade == "MANAGER"
                                      ? "운영자"
                                      : "" -->
                                </span>
                              </v-btn>
                            </template>
                            <div class="dropdown-list" v-if="isInternalUser">
                              <UserTooltip :userId="paperUserItem.userId" />
                            </div>
                          </v-menu>
                        </div>
                        <div
                          class="mail"
                          v-if="!(paperUserItem.userId === userInfo.userId)"
                        >
                          {{ paperUserItem.companyName }} /
                          {{
                            paperUserItem.isExternalUser
                              ? paperUserItem.partnerName
                              : paperUserItem.deptName
                          }}
                        </div>
                        <button
                          type="button"
                          class="logout"
                          v-show="
                            !(paperUserItem.userId === userInfo.userId) &&
                            inherit == 0 &&
                            currentGrade == 'MANAGER'
                          "
                          @click="rejectBoardMember(paperUserItem, 'REJECT')"
                        >
                          {{$i18nUtil.trans("button.except","제외")}}
                        </button>
                      </li>
                    </ul>
                  </dd>
                </dl>
              </div>
            </div>
          </v-menu>
        </div>

        <div class="board_util">
          <!-- TODO 정보공유 보드의 경우 조회 수, 좋아요 수 추가 필요 -->
          <div
            type="button"
            class="ico-txt_see large"
            v-if="boardSection[0] == 'SHAR'"
          >
            {{ paperInfo.paperLookupCount }}
          </div>
          <button
            type="button"
            class="ico-switch-txt_like large permit_everyone"
            :class="paperInfo.paperLikeYN != null ? 'active' : ''"
            @click="
              $dm($event).clt('active');
              toggleInfoSharePaperLike();
            "
            v-if="boardSection[0] == 'SHAR'"
          >
            {{ paperLikeCount }}
          </button>

          <!--
            <button type="button" class="ico-switch-txt_like large" @click="$dm($event).clt('active')"> 0 </button>
          -->
          <!-- TODO 알림 2.0 기준 숨김처리 요건 정리 후 적용필요 -->
          <!--
            <button type="button" class="ico-switch_alarm large" :class="notiExceptTarget == null ? '' : 'active'" @click="setNotiExceptTarget"> 알림 </button>
          -->
          <button
            type="button"
            class="ico-switch_favorites large permit_everyone"
            :class="paperBookmarkId != null ? 'active' : ''"
            @click="
              $dm($event).clt('active');
              toggleBookmark();
            "
          >
            {{$i18nUtil.trans("button.bookmark","북마크")}}
          </button>

          <div class="droplayer icon more large right ty3 nosel">
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="permit_everyone" v-bind="attrs" v-on="on"
                  >{{$i18nUtil.trans("button.etc","기타영역")}}</v-btn
                >
              </template>
              <div class="dropdown-list">
                <div class="dropdown-list-item">
                  <div class="tit">
                    <button
                      type="button"
                      class="permit_everyone"
                      @click="openPaperNewWindow()"
                    >
                      {{$i18nUtil.trans("button.paper.open.newWindow","새 창으로 보기")}}
                    </button>
                  </div>
                </div>
                <div class="dropdown-list-item" v-if="tenantId !== '203'">
                  <div class="tit">
                    <button
                      type="button"
                      class="permit_everyone"
                      @click="openBoardHistoryModal()"
                    >
                      {{$i18nUtil.trans("button.activityHistory","활동 내역")}}
                    </button>
                  </div>
                </div>
                <div class="dropdown-list-item">
                  <div class="tit">
                    <button
                      type="button"
                      class="permit_everyone"
                      @click="paperAllComment(true)"
                    >
                      {{$i18nUtil.trans("button.selectOpinion","의견 전체 검색")}}
                    </button>
                  </div>
                </div>
                <div
                  class="dropdown-list-item"
                  v-if="
                    isInternalUser &&
                    (boardSection[0] == null || boardSection[0] == 'PRIV') &&
                    isSharUse
                  "
                >
                  <div class="tit">
                    <button
                      type="button"
                      class="hide_readonly"
                      @click="onInfoSearchShare"
                    >
                      {{$i18nUtil.trans("button.pushShare","정보공유 게시")}}
                    </button>
                  </div>
                </div>
                <div
                  class="dropdown-list-item"
                  v-if="
                    isInternalUser &&
                    (boardSection[0] == null || boardSection[0] == 'PRIV') &&
                    isCfrcUse
                  "
                >
                  <div class="tit">
                    <button
                      type="button"
                      class="hide_readonly"
                      @click="onCooperationModal"
                    >
                      {{$i18nUtil.trans("button.pushCfrc","회의/협의 게시")}}
                    </button>
                  </div>
                </div>
                <div
                  class="dropdown-list-item"
                  v-if="true || paperInfo.inOutKbn === 'OUT'"
                >
                  <div class="tit">
                    <button
                      type="button"
                      class="permit_everyone"
                      @click="
                        boardUtil.copyClipboard(boardUtil.currentURL());
                        toastInfo.message = $i18nUtil.trans('TB010');
                        showToast(toastInfo);
                      "
                    >
                    {{tenantId === '201' && boardSection[0] === "SHAR" ? $i18nUtil.trans("button.sharPaper.copy.url","HO! URL 복사") : $i18nUtil.trans("button.paper.copy.url","보드 URL 복사")}}
                    </button>
                  </div>
                </div>
                <div
                  class="dropdown-list-item"
                  v-if="isInternalUser && (tenantId=='201' || (paperInfo.permission > 1)) && tenantId != '203'"
                >
                  <div class="tit">
                    <button
                      type="button"
                      class="permit_everyone"
                      @click="copyPaperModal(paperInfo, false)"
                    >
                    {{tenantId === '201' && boardSection[0] === "SHAR" ? $i18nUtil.trans("button.sharPaper.copy","HO! 복제") : $i18nUtil.trans("button.paper.copy","보드 복제")}}
                    </button>
                  </div>
                </div>
                <div
                  class="dropdown-list-item"
                  v-if="isInternalUser && tenantId=='201'&& boardSection[0] == 'SHAR' "
                >
                  <div class="tit">
                    <button
                      type="button"
                      class="permit_everyone boardCopy"
                      @click="copyPaperModal(paperInfo,true)"
                      :boardCopy="boardCopy"
                    >
                      {{$i18nUtil.trans("button.paper.copy","할 일 복제")}}
                    </button>
                  </div>
                </div>
                <!-- 2020-11-27 한화생명은 내부망 이관 삭제로 안나오도록 처리 -->
                <div class="dropdown-list-item" v-if="false">
                  <div class="tit">
                    <button type="button" class="hide_readonly">
                      {{$i18nUtil.trans("button.moveIn","내부망 이관")}}
                    </button>
                  </div>
                </div>
                <!-- 보드 삭제는 보드 생성자만 가능함 -->
                <div
                  class="dropdown-list-item"
                  v-if="
                    isInternalUser && paperInfo.regUserId == userInfo.userId
                  "
                >
                  <div class="tit">
                    <button
                      type="button"
                      class="hide_readonly"
                      @click="deletePaper()"
                    >
                      {{tenantId === '201' && boardSection[0] === "SHAR" ? $i18nUtil.trans("button.paper.sharDelete","HO! 삭제") : $i18nUtil.trans("button.paper.delete","보드 삭제")}}
                    </button>
                  </div>
                </div>
                <div
                  class="dropdown-list-item"
                  v-if="isInternalUser && paperInfo.regUserId == userInfo.userId && docGrade === 'RESTRICT' && permissionUse==='true'"
                >
                  <div class="tit">
                    <button
                      type="button"
                      class="hide_readonly"
                      @click="permissionAssignment()"
                    >
                      {{$i18nUtil.trans("button.paper.permission.assignment","생성자 권한 이전")}}
                    </button>
                  </div>
                </div>
              </div>
            </v-menu>
          </div>
        </div>
      </div>
    </div>
    <!-- /[업무보드 컨텐츠 > 상단부 영역] -->
    <div class="tab-content">
      <!-- [업무보드 컨텐츠 > 업무보드 편집기 탭 영역] -->
      <BoardEditor
        ref="boardEditor"
        v-show="currentTab == 0"
        :paperInfo="paperInfo"
        :startDay="startDay"
        :endDay="endDay"
        :blockInfo="blockInfo"
        :category="category"
        :paperLockYn="paperLockYn"
        :superiorMgrYn="superiorMgrYn"
        :paperStatus="paperStatus"
        :lastUpdInfo="lastUpdInfo"
        :transmitter="transmitter"
        :userInfo="userInfo"
        :boardMemberInfo="boardMemberInfo"
        :todoSelectedblockId="todoSelectedblockId"
        :projectInfo="projectInfo"
        :boardSection="boardSection"
        :memberSelector="$refs.memberSelector"
        :boardUtil="boardUtil"
        :isRoute="isRoute"
        @saveBoard="saveBoard"
        @moveSortBlock="moveSortBlock"
        @changeCategory="changeCategory"
        @changePaperLockYn="changePaperLockYn"
        @changePaperSuperiorYn="changePaperSuperiorYn"
        @changePaperStatus="changePaperStatus"
        @changePaperPeriod="changePaperPeriod"
        @paperAllComment="paperAllComment"
        @refreshBoardMemberInfo="initPaperUserList"
        @setUploadData="setUploadData"
        @fileUpload="fileUpload"
        @showModal="showModal"
      />
      <!-- [업무보드 컨텐츠 > 업무보드 할 일 영역] -->
      <BoardTodo ref="boardTodo" v-show="currentTab == 2" />
      <!-- [업무보드 컨텐츠 > 업무보드 파일 영역] -->
      <BoardFiles
        ref="boardFiles"
        v-show="currentTab == 1"
        :paperInfo="paperInfo"
      />
    </div>
    <BoardComment
      :userInfo="userInfo"
      :boardUtil="boardUtil"
      :paperInfo="paperInfo"
      :blockInfo="blockInfo"
      :memberSelector="$refs.memberSelector"
      :emoticonSelector="$refs.emoticonSelector"
      :emoticonUse="emoticonUse"
      :emoticonItem="emoticonItem"
      :boardMemberInfo="boardMemberInfo"
      :allMemberId="allMemberId"
      @initPaperUserList="initPaperUserList"
      v-if="boardSection[0] != 'SNAPSHOT'"
    />
    <CommentSearch
      :userInfo="userInfo"
      :boardUtil="boardUtil"
      :paperInfo="paperInfo"
      :blockInfo="blockInfo"
      :memberSelector="$refs.memberSelector"
      :boardMemberInfo="boardMemberInfo"
      v-if="boardSection[0] != 'SNAPSHOT'"
    />
    <!-- [호출멤버 선택기 영역] -->
    <!-- 회사 임직원 전체 조회: searchNonMember === true -->
    <!-- 보드에 속한 멤버만 조회: searchNonMember === false -->
      <MemberListSelector
        id="board-members-selector"
        ref="memberSelector"
        class="hidden"
        :groupId="paperInfo.groupId"
        :paperId="paperInfo.paperId"
        :localUserList="boardMemberInfo.userList"
        :memberOnly="boardSection[0] != 'SNAPSHOT' && searchNonMember === false"
        :callLocation="'board'"
        :allMemberId="allMemberId"
        :section="paperInfo.categoryInfo != null ? paperInfo.categoryInfo.section : null"
        :pDocGrade="paperInfo.docGrade"
        :cDocGrade="paperInfo.categoryInfo != null ? paperInfo.categoryInfo.docGrade : null"
      />
    <!-- /[호출멤버 선택기 영역] -->

    <!-- [이모티콘 선택기 영역] -->
    <EmoticonSelector 
      id="board-emoticon-selector"
      ref="emoticonSelector"
      :emoticonList="emoticonList"
     />
    <!-- /[이모티콘 선택기 영역] -->

    <!-- 과제 추가하기 팝업 S -->
    <HwLayerPop @close="closeModal" v-if="modalBgNone">
      <template slot="tit">
        <div class="tit">{{$i18nUtil.trans("entity.project","과제")}} 추가하기</div>
        <button type="button" class="add" @click="openModal2">+</button>
      </template>
      <ul class="task_box">
        <li>
          <b>디지털/글로벌 종합금융사 기반 구축</b>
          <span>Digital C.P. 기반 구축</span>
          <div class="btn_grp">
            <button type="button" class="link">공유</button>
            <button type="button" class="del">{{$i18nUtil.trans("button.delete","삭제")}}</button>
          </div>
        </li>
        <li>
          <b>마케팅 브랜딩 강화</b>
          <span>LIFEPLUS 광고 매체 확대 전략</span>
          <div class="btn_grp">
            <button type="button" class="share">공유</button>
            <button type="button" class="del">{{$i18nUtil.trans("button.delete","삭제")}}</button>
          </div>
        </li>
      </ul>
    </HwLayerPop>
    <!-- 과제 추가하기 팝업 E -->

    <!-- 과제 추가하기 팝업 S -->
    <HwLayerPop @close="closeModal2" v-if="modalBgNone2">
      <template slot="tit">
        <div class="tit">{{$i18nUtil.trans("entity.project","과제")}} 선택</div>
        <button
          type="button"
          class="btn_close btn_out"
          @click="closeModal2"
        ></button>
      </template>
      <div class="task-select">
        <div class="scroll_box">
          <div class="tit">디지털/글로벌 종합금융사 기반 부축</div>
          <ul class="list">
            <li>- Digital C.P.C. 기반 구축</li>
            <li>- Digital Infra 구축</li>
          </ul>
          <div class="tit">마케팅 목표명 노출</div>
          <ul class="list">
            <li>- Digital C.P.C. 기반 구축</li>
            <li>- Digital Infra 구축</li>
          </ul>
        </div>
      </div>
    </HwLayerPop>
    <!-- 과제 추가하기 팝업 E -->
    <!-- 더보기 활동내역-->
    <!-- <HwModalFull
      @close="closeBoardHistoryModal"
      v-if="showBoardHistory"
      style="width: 100%"
    > -->
    <!-- <template slot="tit">
        <div class="tit">활동내역</div>
      </template> -->
    <!-- default 슬롯 콘텐츠 -->
    <!-- <BoardHistory :paperInfo="paperInfo" @$="$" /> -->
    <!-- /default -->
    <!-- footer 슬롯 콘텐츠 -->
    <!-- <template slot="footer">
        <div></div>
      </template> -->
    <!-- /footer -->
    <!-- </HwModalFull> -->
    <!-- 더보기 활동내역 E -->
  </section>
</template>

<script>
import Vue from "vue";
import SockJS from "sockjs-client";
import Stomp from "webstomp-client";
import axios from "axios";
import { mapState, mapActions, mapMutations } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import EventBus from "@/js/eventbus/eventBus";
/* 업무보드 편집기 탭 */
import BoardEditor from "../editor/BoardEditor";
/* 할 일탭 */
import BoardTodo from "../todo/BoardTodo";
/* 보드 할 일 */
import Todo from "../todo/popup/Todo";
/* 파일탭 */
import BoardFiles from "../files/BoardFiles";
/* 블럭 의견 입력 */
import BoardComment from "../comment/BoardComment";
/* 의견 전체보기 & 검색 */
import CommentSearch from "../comment/CommentSearch";
/* 활동내역 */
import BoardHistory from "../modal/history/BoardHistory";
/* 활동내역 모달 */
import HwModalFull from "../modal/HwModalFull";
/* 팝업 */
import HwLayerPop from "../base/HwLayerPop";
/* 정보공유 게시 팝업 */
//import InfoSearchShareModal from "../modal/InfoSearchShare_Modal";
import InfoSearchShareModal from "@/components/cowork/general/project/modal/ReqPostModal";
/* 보드복제 팝업 */
import CopyBoardModal from "../modal/CopyBoardModal";
import CopyCooperationBoardModal from "../modal/CopyCooperationBoardModal";
import CopyInfoShareBoardModal from "../modal/CopyInfoShareBoardModal";

/* 나의 과제 선택 팝업 */
import BoardLinkProject from "../modal/BoardLinkProject";
/* 조직도 팝업 */
import MultiOrg from "../../../common/organization/org/MultiOrg";
/* 호출멤버 선택기 */
import MemberListSelector from "../extensions/MemberListSelector";
/* 호출멤버 선택기 */
import BoardLinkedOkr from "@/components/cowork/general/board/modal/BoardLinkedOkr";
/* 보드 유틸 */
import BoardUtil from "./BoardUtil.js";
/* 이모티콘 */
import EmoticonSelector from '../../../common/emoticon/EmoticonSelector';
/* codeValue 조회 */
import codeValueJs from '@/js/codeValue/codeValue';
/* 생성자 권한 이전 팝업 */
import PaperPermissionModal from "../modal/PaperPermissionModal";

export default {
  name: "tabs",
  components: {
    HwLayerPop,
    BoardEditor,
    BoardTodo,
    BoardFiles,
    BoardComment,
    CommentSearch,
    BoardHistory,
    HwModalFull,
    UserTooltip,
    MemberListSelector,
    EmoticonSelector,
  },
  props: {
    userInfo: Object,
    paperInfo: Object,
    boardSection: Array,
    boardMemberInfo: Object,
    todoSelectedblockId: String,
    
  },
  data() {
    let tenantId = localStorage.getItem("tenantId");
    return {
      /* tenantId */
      tenantId: tenantId,
      /* 로그인한 사용자의 권한 */
      currentGrade: "",
      /* 현재탭 */
      currentTab: 0,
      /* 탭종류들 */
      tabs: [this.$i18nUtil.trans("entity.paper.groupKbn.pro","과제 보드"), /* this.$i18nUtil.trans("entity.todo","할 일"), */ this.$i18nUtil.trans("message.BoardContents.001","파일")],
      modalBgNone: false,
      modalBgNone2: false,
      /* 업무보드&블럭 주요데이터 */
      edts: { edtData: [], edtObj: [] },
      /* timeInterval 정보, 후처리를 위해 사용 */
      reconnectionFunc: null,
      /* 카테고리 리스트 */
      category: {
        categoryList: [],
        selectedCategory: {},
      },
      /* 과제 보드의 경우 공개여부 */
      publicYn: 0,
      /* 업무보드 문서등급 */
      docGrade: null,
      projectCount: 0,
      projectInfo: {},
      projectName: this.$i18nUtil.trans("message.BoardContents.010","디지털기획팀"),
      /* 업무보드 잠금상태 */
      paperLockYn: "0",
      /* 업무보드 상위관리자 참조 */
      superiorMgrYn: "0",
      paperBookmarkId: null,
      /* 업무보드 진행상태 */
      paperStatus: null,
      startDay: null,
      endDay: null,
      lastUpdInfo: {
        lastUpdUserName: null,
        lastUpdUserNameEn: null,
        lastUpdDate: null,
      },
      searchNonMember: null, // 호출: 멤버 외 사용자 검색 여부
      searchMemberList: [],
      searchNoMemberList: [],
      userList: [],
      paperUserCount: 0,
      searchMemberInput: "",
      isMemberSearch: false,
      searchUserList: [],
      inherit: 1,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      /* 최소높이 지정 (미지정시 컨텐츠 화면이 비어보임) */
      dBHeight: {
        "min-height": window.innerHeight + 310 + "px",
      },
      isFixed: false,
      /* 활동내역팝업 */
      showBoardHistory: false,
      /* STOMP 핸들러 체인(어레이), 각 블럭의 STOMP 핸들러 연결을 위해 사용한다. */
      transmitter: { subscribers: {} },
      /* 업무보드 STOMP 처리 직후 연계시킬 정보들의 임시 저장소 */
      blockInfo: {
        paperBlockIdList: [],
        paperBlockMap: {},
        deletedBlocks: [],
        commentCounts: {},
        editingMap: {},
        commentSelectId: false,
      },
      /* 뒤로가기 URL */
      routerReturnUrl: null,

      /* 알림차단 유무  */
      notiExceptTarget: null,
      /* 보드유틸 */
      boardUtil: BoardUtil,
      socket: null,
      paperLikeCount: 0,
      /* 내부 사용자 여부 */
      isInternalUser: false,
      /* 선택된 OKR분기 */
      currentQrt: {
        qrtCd: "",
        qrtTopMsg: "",
        qrtTopMsgEn: null
      },
      qrtList: [],
      paperKrLinkList: [],
      paperKrLinkCount: 0,
      okrUseFlag: false,
      isCfrcUse: false,
      isSharUse: false,
      tenantId: localStorage.getItem("tenantId"),
      emoticonUse: null,
      emoticonList: {},
      emoticonItem: 'brdCommentEmoticon',
      /* 전체멤버 호출 시, userId 값 */
      allMemberId: "cowork.mention.allMember",
      boardCopy: true,
      isRoute: false, // 라우터 이동 감지
      orgMapUse: localStorage.getItem("orgMapUse"), // 조직도로 멤버추가하기 사용여부
      permissionUse: localStorage.getItem("permissionUse") // 보드 생성자 권한 이전 사용여부
    };
  },
  created() {
    const self = this;
    
    if(localStorage.getItem("targetBlockId") != null){
      self.setNotiBoardBlockId(localStorage.getItem("targetBlockId"));
      // localStroage 값 제거
      localStorage.removeItem("targetBlockId");
    }
    if(localStorage.getItem("targetCommentId") != null){
      self.setNotiBoardCommentId(localStorage.getItem("targetCommentId"));
      // localStroage 값 제거
      localStorage.removeItem("targetCommentId");
    }
    
    $("html").click(function (e) {
      if (!$(e.target).hasClass("member-call-box")) {
        self.isMemberSearch = false;
      }
    });
    EventBus.$off("updatePaperUser");
    EventBus.$on("updatePaperUser", () => {
      // console.log("updatePaperUser");
      this.initPaperUserList();
    });

    this.boardUtil.initBoardContent(this, axios);
    window.addEventListener("scroll", this.handleScroll);
    // 의사결정/의견 이모티콘 사용 여부
    this.emoticonUse = this.$emoticonFn.getEmoticonLocation(null);
    // 멤버 호출: 멤버 외 사용자 검색 여부
    this.setSearchNonMember();

    let currentURL = window.location.href;
    let match = /^(.+)\/(board|boardViewer|boardTarget)\/(PAPE[a-zA-Z0-9]+)([/?].*){0,1}/.exec(
      currentURL
    );
    if (match && match.length > 4 && match[4]) {
      let str = match[4].replace(/^[/?]+/g, "");
      if (str === "test=test") {
        this.testmode = "test";
      }
    }
  },
  mounted() {
    this.routerReturnUrl = localStorage.getItem("returnUrl");
    this.checkOrderList();
    this.checkOrgMapUse();
    this.checkPermissionUse();
    // if(localStorage.getItem("orderListUse") == null){
    //   this.checkOrderList();
    // }
    // if(localStorage.getItem("orgMapUse") == null){
    //   this.checkOrgMapUse();
    // }
    
    /* 후처리가 되지 않은경우 마저 클리어 */
    if (this.reconnectionFunc) {
      clearInterval(this.reconnectionFunc);
    }
    /**
     * 커넥션부하 테스트해야 할 필요가 있을경우 아래 주석 해제 (IE 등)
     * 최대접속갯수, heartbeat 등을 조절하여 테스트한다.
     **/
    // for (let inx = 0; inx < 6; inx++) {
    //   let socket = new SockJS("/api/copaper/websocket",
    //     { debug: false, protocols: Stomp.VERSIONS.supportedProtocols() })
    //   let stompClient = Stomp.over(socket);
    //   stompClient.heartbeat.outgoing = 5000;
    //   stompClient.heartbeat.incoming = 0;
    //   stompClient.reconnect_delay = 5000;
    //   stompClient.connect(
    //     { login: "mylogin", passcode: "mypasscode", 
    //       Authorization: localStorage.getItem("Authorization"), },
    //     (frame) => { }, (error) => { console.log("ERROR:", error); }
    //   );
    // }
    this.connect();
    // 2020-11-27 의견영역 처음에 로드 안되도록 하는게 맞다고함... 경원씨 확인사항
    // 2020-12-14 의견영역 처음에 로드되도록 수정
    // 2021-01-05 SNAPSHOT은 의견영역 안보여준다.
    if (this.boardSection[0] == "SNAPSHOT" || this.tenantId == '201') {
      this.paperAllComment(false);
    } else {
      this.paperAllComment(true);
    }
    /* 알림 유무  */
    this.getNotiExceptTarget();
    this.$store.state.project.paperRegUser = this.paperInfo.regUserId;
  },
  watch: {
    boardSection: {
      handler() {
        this.paperLikeCount = this.paperInfo.paperLikeCount;
        if (this.boardSection[0] === "SHAR") {
          this.tabs[0] = this.$i18nUtil.trans("message.BoardContents.011","정보 보드");
        } else if (this.boardSection[0] === "CFRC") {
          this.tabs[0] = this.$i18nUtil.trans("message.BoardContents.012","회의 보드");
        } else if (this.boardSection[0] === "PRIV") {
          this.tabs[0] = this.$i18nUtil.trans("message.BoardContents.013","프라이빗 보드");
        }
      },
      // deep: true,
    },
    "paperInfo.permission": {
      handler() {
        if (this.paperInfo.permission < 2) {
          this.paperInfoRefreshHandler(true);
        }
        else {
          this.paperInfoRefreshHandler(false);
        }
      }
    },
    emoticonUse() {
      if(this.emoticonUse != null) {
        this.checkEmoticonUse();
      }
    },
    checkOrgMapUseYn: function(){
      this.orgMapUse = localStorage.getItem("orgMapUse");
		},
    checkRegUser: function(){
      this.workBoardAPI("CONNECT");
		}
  },
  computed: {
    checkOrgMapUseYn: function(){
			return this.orgMapUse;
		},
    checkRegUser: function(){
			return this.$store.state.project.paperRegUser;
		},
  },
  updated() {
    this.$nextTick(() => {
      if (this.paperInfo.connected && this.paperInfo.permission > 0) {
        this.paperInfoRefreshHandler(true);
      }
    });
    {
      let list = this.$el.querySelectorAll("div.img.user-photo");
      if (list) {
        for (let inx = 0; inx < list.length; inx++) {
          let elem = list[inx];
          let userId = elem.getAttribute("data-user-id");
          let img = elem.querySelector("img");
          this.HW_GET_USER_PHOTO({ img, userId });
        }
      }
    }
  },
  beforeDestroy() {
    /* 후처리 (소캣 재접속 스레드 클리어) */
    try { this.boardUtil.clearBlockLock(); } catch (ignore) { }
    try { clearInterval(this.reconnectionFunc); } catch (ignore) { }
    try { this.stompClient.disconnect(() => {}); } catch (ignore) { }
    try { this.socket.close(); } catch (ignore) { }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("coworkUtils", ["HW_GET_USER_PHOTO", "HW_KEYGEN", "ERR_REPORT"]),
    ...mapActions("noti",["setNotiBoardBlockId","setNotiBoardCommentId","setEventBackYn"]), 
    ...mapMutations("project",["setPaperRegUser"]), 
    ...mapState("project", ["setPaperRegUser"]),
    updateAccessDay(groupId){
      let obj = this;
      let reqData = {};
      reqData.params = {
        groupId:groupId
      };
      reqData.req = obj.req;
      reqData.url = "/api/cogroup/cogroup/updateLastAccessDay";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => { })
        .catch(function (err) { console.log(err); });
    },
    handleScroll(event) {
      for (let elementId of ["paperAllComment", "board-comment"]) {
        let element = document.getElementById(elementId);
        let tableBubbleMenu = document.getElementById("mock_table_bubble_menubar"); // 테이블 버블 메뉴
        if (element) {
          let scrollY = window.scrollY || window.pageYOffset;
          // console.log("SCROLL:", scrollY);
          if (scrollY > 79) {
            this.isFixed = true;
            element.classList.add("top");
            // console.log("addFixed");
          } else {
            this.isFixed = false;
            element.classList.remove("top");
            // console.log("removeFixed");
          }
        }
      }
    },
    paperInfoRefreshHandler(readOnly = true) {
      let self = this;
      let root = self.$el;
      let timeout = null;
      if (root.classList.contains("readonly")) {
        let fncCheckBtn = function (btn, readOnly = true) {
          /* 예외버튼들 필터링 */
          if (readOnly) {
            if (btn.classList.contains("permit_everyone")) {
              return true;
            }
            btn.style.cursor = "text";
            if (!btn.getAttribute("disabled")) {
              btn.setAttribute("disabled", true);
            }
            return false;
          }
          else {
            if (btn.getAttribute("disabled")) {
              btn.style.cursor = "pointer";
              btn.removeAttribute("disabled");
            }
          }
        };
        let fncReadOnly = function (readOnly = true) {
          /* 읽기전용인 경우 모든 버튼 비활성화  */
          for (
            let eList = self.$dm(self.$el).qa(".board-tab1 button"), einx = 0;
            einx < eList.length;
            einx++
          ) {
            fncCheckBtn(eList[einx], readOnly);
          }
          for (
            let eList = self.$dm(self.$el).qa(".board-header button"), einx = 0;
            einx < eList.length;
            einx++
          ) {
            fncCheckBtn(eList[einx], readOnly);
          }
          /* 테이블 칼럼내용이 없으면 찌그러져 보임 */
          let fncTbColumns = function (el) {
            if (!el.innerText) {
              el.innerHTML = "<p>&nbsp;</p>";
            }
          };
          for (
            let eList = self.$dm(self.$el).qa(".editor-wrapper td"), einx = 0;
            einx < eList.length;
            einx++
          ) {
            fncTbColumns(eList[einx]);
          }
          for (
            let eList = self.$dm(self.$el).qa(".editor-wrapper th"), einx = 0;
            einx < eList.length;
            einx++
          ) {
            fncTbColumns(eList[einx]);
          }

          /* 일반텍스트 공백문단은 찌그러져 보임 */
          for (
            let eList = self.$dm(self.$el).qa(".editor-wrapper p"), einx = 0;
            einx < eList.length;
            einx++
          ) {
            if (!eList[einx].innerText) {
              eList[einx].innerHTML = "&nbsp;";
            }
          }
          /* 날자입력박스 */
          for (
            let eList = self.$dm(self.$el).qa(".editor-wrapper p"), einx = 0;
            einx < eList.length;
            einx++
          ) {
            if (readOnly) {
              if (!eList[einx].getAttribute("disabled")) {
                eList[einx].setAttribute("disabled", true);
              }
            }
            else {
              if (eList[einx].getAttribute("disabled")) {
                eList[einx].removeAttribute("disabled");
              }
            }
          }
          timeout = null;
        };
        if (timeout) {
          clearTimeout(timeout);
        }
        timeout = setTimeout(() => { fncReadOnly(readOnly); }, 500);
      }
    },
    guideLine(show) {
      /* 가이드라인 */
      let interval = 384;
      let body = this.$dm(this.$el);
      let width = window.innerWidth;
      let height = window.innerHeight;
      body.qa("div.guide_line").forEach((el) => {
        body.removeChild(el);
      });
      if (show) {
        for (let inx = 0; inx < width; inx++) {
          if (inx > 0 && inx % interval == 0) {
            let div = this.$dm(document.createElement("div"));
            div
              .cla("guide_line")
              .at("style", "left:" + inx + "px; height:" + height + "px");
            body.appendChild(div);
          }
        }
      }
    },
    openModal() {
      // this.modalBgNone = true;
      let obj = this;
      if (obj.paperInfo.permission < 2) {
        obj.toastInfo.message = obj.$i18nUtil.trans("TB044");
        obj.showToast(obj.toastInfo);
        return;
      }

      const modalInfo = {
        title: this.$i18nUtil.trans("title.BoardLinkProject.001","과제 링크 내역"),
        name: "myProjectSelect",
        method: "post",
        width: "800px",
        obj: this.$modal,
        paperId: this.paperInfo.paperId,
        userInfo: this.userInfo,
        paperRegUserId: this.paperInfo.regUserId,
        groupId: this.paperInfo.groupId,
        component: BoardLinkProject,
      };
      this.showModal(modalInfo);
    },
    openModal2() {
      this.modalBgNone2 = true;
    },
    closeModal() {
      this.modalBgNone = false;
    },
    closeModal2() {
      this.modalBgNone2 = false;
    },
    /* 업무보드 문서등급 변경 */
    changePaperDocGrade(docGradeCode) {
      let obj = this;
      if (obj.paperInfo.regUserId != obj.userInfo.userId) {
        obj.toastInfo.message = obj.$i18nUtil.trans("AB082");
        obj.showToast(obj.toastInfo);
        return;
      }
      if (obj.paperInfo.docGrade == docGradeCode) {
        return;
      }
      let changePaperDocGradeCallback = function () {
        let url = "/api/copaper/paper/updatePaperDocGrade";
        let param = {
          paperId: obj.paperInfo.paperId,
          docGrade: docGradeCode,
        };
        axios
          .post(url, param)
          .then((res) => {
            if (res.data.errorCode != null) {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB044");
              obj.showToast(obj.toastInfo);
              return;
            }
            obj.docGrade = docGradeCode;
            if (obj.docGrade == "NORMAL") {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB037");
              obj.showToast(obj.toastInfo);
            } else if (obj.docGrade == "RESTRICT") {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB038");
              obj.showToast(obj.toastInfo);
            } else if (docGradeCode == "SECRET") {
              obj.initPaperUserList();
            }
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });
      };
      if (docGradeCode == "SECRET") {
        obj.showConfirmDialogWithJSON({
          modalSize: {
            width: "520px",
            // height: "180px",
          },
          confirmMessage: obj.$i18nUtil.trans("AB066"),
          confirmBtnText: obj.$i18nUtil.trans("message.BoardContents.014","설정"),
          confirmBtnCallback: changePaperDocGradeCallback,
          cancelBtnText : obj.$i18nUtil.trans("button.cancel","취소")
        });
      } else {
        changePaperDocGradeCallback();
      }
    },
    /* 업무보드 잠금상태 변경 */
    changePaperLockYn(paperLockYn) {
      paperLockYn = String(paperLockYn) === "1" ? "0" : "1";
      let url = "/api/copaper/paper/updatePaperLockYn";
      let param = {
        paperId: this.paperInfo.paperId,
        lockYn: paperLockYn,
      };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("changePaperLockYn error", res.data.errorCode);
            // return;
          }
          obj.paperLockYn = paperLockYn;
          obj.toastInfo.message =
            paperLockYn == "1" ? obj.$i18nUtil.trans("TB006") : obj.$i18nUtil.trans("TB007");
          obj.showToast(obj.toastInfo);
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 업무보드 상위관리자 참조 변경 */
    changePaperSuperiorYn(superiorMgrYn) {
      superiorMgrYn = String(superiorMgrYn) === "1" ? "0" : "1";
      let url = "/api/copaper/paper/updatePaperSuperiorMgrYn";
      let param = {
        paperId: this.paperInfo.paperId,
        superiorMgrYn: superiorMgrYn,
      };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("updatePaperSuperiorMgrYn error", res.data.errorCode);
            // return;
          }
          obj.superiorMgrYn = superiorMgrYn;
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 의견 전체검색창 토글 */
    paperAllComment(show) {
      let element = document.getElementById("paperAllComment");
      if (element) {
        if (show) {
          EventBus.$emit("commentedAll", "commentedAll");
          element.classList.remove("active");
          /* 열려있는 의견창이 있다면 닫아준다 */
          if (this.blockInfo.commentSelectId) {
            this.blockInfo.commentSelectId = "";
          }
        } else {
          element.classList.add("active");
        }
      }
    },
    /* 업무보드 API */
    workBoardAPI(sendId, param) {
      /**
       * 정의된 param 정보를 이용해 apiCall 메소드를 호출한다.
       **/
      let self = this;
      let params = {
        /* 드래그&드롭시 블럭 재배치 */
        moveSortBlock: {
          uri: "/block/moveSortBlock",
          param: {
            paperId: String(self.paperInfo.paperId),
            blockId1: param && param.blockId1 ? String(param.blockId1) : null,
            blockId2: param && param.blockId2 ? String(param.blockId2) : null,
          },
        },
        /* 최초연결시 수행하는 API */
        CONNECT: [
          {
            /* 보드정보 & 사용자정보 받아오기 */
            uri: "/paperInfo",
            param: { paperId: self.paperInfo.paperId },
            callback: function (res) {
              let permission = 0;
              if (res.data && res.data.result) {
                // 삭제된 보드입니다.
                let deleteYn = res.data.result.paperInfo.deleteYn || 0;
                let groupDeleteYn =
                  res.data.result.paperInfo.groupDeleteYn || 0;
                if (
                  res.data.result.paperInfo != null &&
                  (deleteYn == 1 || groupDeleteYn == 1)
                ) {
                  self.toastInfo.message = self.$i18nUtil.trans("TB045");
                  self.showToast(self.toastInfo);
                  history.go(-1);
                  return;
                }
                self.setPaperInfo(res.data.result.paperInfo);
                self.setUserInfo(res.data.result.userInfo);
                self.paperInfo.inOutKbn = res.data.result.inOutKbn;
                self.paperInfo.accessType = res.data.result.accessType;
                self.paperInfo.useExternalSite = res.data.result.useExternalSite;
                self.isCfrcUse = res.data.result.cfrcUse;
                self.isSharUse = res.data.result.sharUse;
                let auth = res.data.fncAuthRst;
                if (auth && auth.allow == true && auth.authFlag) {
                  let authFlag = auth.authFlag;
                  if (authFlag === "RW") {
                    permission = 2;
                  } else if (authFlag === "R") {
                    permission = 1;
                  } else {
                    permission = 0;
                  }
                } else {
                  permission = 0;
                }

                /* SNAPSHOT의 경우 퍼미션을 1로 강제함 */
                if (self.boardSection[0] == "SNAPSHOT") {
                  permission = 1;
                }

                if (permission > 0) {
                  if (self.paperInfo.readonly) {
                    permission = 1;
                  }
                  self.paperInfo.permission = permission;
                } else {
                  // self.toastInfo.message = "이 업무보드를 조회할 권한이 없습니다.";
                  // self.showToast(self.toastInfo);
                  history.go(-1);
                  return;
                }
                /* 의사결정 영역에 데이터 전달 */
                EventBus.$emit("updatePaperCommand", {
                  command: "TITLE",
                  paperTitle: self.paperInfo.paperTitle,
                  regUserName: self.paperInfo.regUserName,
                  regUserNameEn: self.paperInfo.regUserNameEn
                });

                /* 그룹에서 공개여부 조회 */
                if (
                  self.paperInfo.groupInfo != null &&
                  self.paperInfo.groupInfo.groupId != null
                ) {
                  self.setGroupPublicYn(self.paperInfo.groupInfo);
                  // 2021-03-04 okr사용여부 조회 추가
                  self.checkOkrUse(self.paperInfo.groupInfo.groupKbn);
                }
                self.updateAccessDay(self.paperInfo.groupId);
              }
            },
          },
          {
            /* 블럭정보 받아오기 */
            uri: "/getPaperBlockIdList",
            param: { paperId: self.paperInfo.paperId },
            callback: function (res) {
              let result = {};
              let error = {
                code: res.errorCode,
                message: res.errorMessage,
              };
              if (error.code) {
                console.log("/getPaperBlockList errorCode", error.message);
              }
              if (res.data.result) {
                result = res.data.result;
                self.$refs.boardEditor.paperBlockIdSubscribe(result, {});
              }
            },
            errCallback: () => {
              setTimeout(location.reload, 1000);
            }
          },
        ],
      };
      self.boardUtil.apiCall(params[sendId]);
    },
    /* 블럭 재배치 */
    moveSortBlock(param) {
      this.workBoardAPI("moveSortBlock", param);
    },
    /* 업무보드 저장 */
    saveBoard() {
      if (this.paperInfo.paperTitle == this.paperInfo.beforePaperTitle) {
        return;
      }
      axios
        .post("/api/copaper/paper/savePaper", {
          paperId: this.paperInfo.paperId,
          paperTitle: this.paperInfo.paperTitle,
        })
        .then((res) => {
          this.toastInfo.message = this.$i18nUtil.trans("TB052");
          this.showToast(this.toastInfo);
          EventBus.$emit("updatePaperCommand", {
            command: "TITLE",
            paperTitle: this.paperInfo.paperTitle,
            regUserName: this.paperInfo.regUserName,
            regUserNameEn: this.paperInfo.regUserNameEn
          });
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 정보공유 팝업 */
    onInfoSearchShare() {
      const modalInfo = {
        title: this.$i18nUtil.trans("message.BoardContents.015","정보공유로 게시"),
        name: "infoShareModal",
        method: "post",
        width: "800px",
        obj: this.$modal,
        paperId: this.paperInfo.paperId,
        component: InfoSearchShareModal,
      };
      this.showModal(modalInfo);
    },
    /* 회의/협의 팝업 */
    onCooperationModal() {
      const modalInfo = {
        title: this.$i18nUtil.trans("message.BoardContents.016","회의/협의체로 게시"),
        name: "cooperationModal",
        method: "post",
        width: "800px",
        obj: this.$modal,
        paperId: this.paperInfo.paperId,
        component: InfoSearchShareModal,
      };
      this.showModal(modalInfo);
    },
    /* 이전페이지로 이동 (백스페이스 혹은 뒤로가기 버튼) */
    goPrevPage() {
      clearInterval(this.reconnectionFunc);
      this.isRoute = true;
      let url = "/api/org/checkSmgr";
      let param = {};
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("checkSmgr error", res.data.errorCode);
            // return;
          }
      
          obj.setEventBackYn(true);
          //let preUrl = localStorage.getItem("boardPreUrl");
          let returnUrls = localStorage.getItem("returnUrls");
          //let beforeUrl = localStorage.getItem("returnDashBoardUrl");
          let isManager = res.data.result;
          if(returnUrls != null) {
            let urlList = returnUrls.split(",");
            if (urlList.length > 0) {
              if (urlList.length == 1) {
                if (
                  urlList[0] === obj.$router.history.current.fullPath ||
                  urlList[0] === "" ||
                  urlList[0] === null ||
                  urlList[0] === undefined
                ) {
                  this.$router.push("/general/home");
                }
              } else {
                for (let i = urlList.length; i > 0; i--) {
                  if (urlList[i - 1].indexOf("/general/viewer") != -1) {
                    urlList.pop();
                  } else if (urlList[i - 1].indexOf("/general/board") != -1) {
                    urlList.pop();
                  } else {
                    obj.$router.replace(urlList[i - 1]);
                    // urlList.pop();
                    localStorage.setItem("returnUrls", urlList);
                    if (this.paperInfo.categoryInfo.section == "SHAR") {
                      let param = {
                        categoryName: obj.paperInfo.categoryInfo.categoryName,
                        categoryMid: obj.paperInfo.categoryInfo.categoryMid,
                      };
                      localStorage.setItem("shareInfo", JSON.stringify(param));
                    } else if (this.paperInfo.categoryInfo.section == "CFRC") {
                      let param = {
                        categoryName: obj.paperInfo.categoryInfo.categoryName,
                        categoryMid: obj.paperInfo.categoryInfo.categoryMid,
                      };
                      localStorage.setItem("cooperation", JSON.stringify(param));
                    }
                    break;
                  }
                }
              }
            } else {
              this.$router.push("/general/home");
            }
          }else{
            this.$router.push("/general/home");
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 업무보드 삭제 */
    deletePaper() {
      let obj = this;
      obj.showConfirmDialogWithJSON({
        confirmMessage: obj.$i18nUtil.trans("AB001"),
        confirmBtnText: obj.$i18nUtil.trans("button.delete","삭제"),
        confirmBtnCallback: obj.deletePaperApiCall,
        cancelBtnText : obj.$i18nUtil.trans("button.cancel","취소"),
      });
    },
    deletePaperApiCall() {
      let obj = this;
      let deleteUrl = "/api/copaper/paper/deletePaper";
      let param = {
        paperId: this.paperInfo.paperId,
        groupId: this.paperInfo.groupId,
        categoryMid: this.paperInfo.categoryMid,
      };
      obj.showLoadingbar();
      axios
        .post(deleteUrl, param)
        .then((res) => {
          obj.hideLoadingbar();
          if (res.data.errorCode != null) {
            if (res.data.errorCode == "PAPER_ID_NOT_NULL") {
              obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardContents.017","보드ID가 없습니다."));
            } else if (res.data.errorCode == "PAPER_GROUP_ID_NOT_NULL") {
              obj.showAlertDialog(obj.$i18nUtil.trans("message.BoardContents.018","공간ID가 없습니다."));
            }
            return;
          }
          if (res.data.fncAuthRst != null) {
            // 삭제 권한이 없을 경우
            if (!res.data.fncAuthRst.allow) {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB056");
              obj.showToast(obj.toastInfo);
              return;
            }
          }

          obj.toastInfo.message = obj.$i18nUtil.trans("TB027");
          obj.showToast(obj.toastInfo);
          obj.$router.push("/general/home");

          // console.log("delete paper success!");
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 피드백 요청하기 */
    reqFeedbackModal() {
      document.getElementById("isWindowPop").value = "";
      const obj = this;
      let hanwha = $(location).attr("origin");
      const windowPop = window.open(
        hanwha + "/general/reqFeedbackModal/" + this.paperInfo.paperId,
        "_blank",
        "width=800, height=924"
      );
      windowPop.addEventListener("unload", (event) => {
        if (document.getElementById("isWindowPop").value == "close") {
          obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardContents.019","피드백 요청을 완료하였습니다.");
          obj.showToast(obj.toastInfo);
          document.getElementById("isWindowPop").value = "";
        }
      });
    },
    /* 최초 소켓연결 */
    connect(reconnected = false) {
      let self = this;
      try {
        const serverUrl = "/api/copaper/websocket";
        self.socket = new SockJS(serverUrl, null, {transports: ["websocket"]});
        self.socket.protocol = 'v12.stomp';
        self.stompClient = Stomp.over(self.socket);
        self.stompClient.heartbeat.outgoing = 20000;
        self.stompClient.heartbeat.incoming = 0;
        self.stompClient.reconnect_delay = 5000;
        self.stompClient.debug = (msg) => {
          //console.log("SOCK:", msg);
        };
        self.stompClient.connect(
          {
            login: "mylogin",
            passcode: "mypasscode",
            Authorization: localStorage.getItem("Authorization"),
          },
          (frame) => {
            self.paperInfo.connected = true;
            self.paperInfo.mounted = true;
            self.onConnected(reconnected);
            if (self.reconnectionFunc != null) {
              clearInterval(self.reconnectionFunc);
              self.reconnectionFunc = null;
            }
            self.reconnectionFunc = setInterval(() => {
              if (!self.stompClient.connected) {
                try { self.stompClient.disconnect(() => {}); } catch (ignore) { }
                try { self.socket.close(); } catch (ignore) { }
                self.connect(true);
              }
            }, 5000);
          },
          (error) => {
            console.log("ERROR:", error);
            self.ERR_REPORT({from:"BoardContent", err:String(error)});
            self.paperInfo.connected = false;
          }
        );
      } catch (e) {
        console.log("E:", e);
      }
      if (!reconnected) {
        setTimeout(() => {
          /* 최초 접속시 5초 후까지 소켓이 열리지 않으면 강제로 소켓 끊고 재접속 시도 */
          if (!self.paperInfo.connected) {
            let msg = "Connection not established over 5sec! Try to reconnect!";
            console.log(msg);
            try { self.ERR_REPORT({from:"BoardContent", err:msg}); } catch (ignore) { }
            try { this.boardUtil.clearBlockLock(); } catch (ignore) { }
            try { clearInterval(this.reconnectionFunc); } catch (ignore) { }
            try { self.stompClient.disconnect(() => {}); } catch (ignore) { }
            try { self.socket.close(); } catch (ignore) { }
            self.connect(false);
          } else {
            console.log("OK! SockJS Connected well")
          }
        }, 5000);
      }
    },
    /* 소켓연결 후 핸들러 바인드 */
    onConnected(reconnected) {
      // console.log("CONNECTED:", reconnected);
      if (!reconnected) {
        this.initCategoryList();
        this.workBoardAPI("CONNECT");
      }
      this.stompSubscribe();
    },
    /* STOMP 소켓 핸들러 (넘어오는 데이터 처리) */
    stompSubscribe() {
      /* init categoryList */
      this.stompClient.subscribe(
        "/api/copaper/topic/paper/subscribe/" + this.paperInfo.paperId,
        (message) => {
          let resData = JSON.parse(message.body);
          let error = {
            code: resData.errorCode,
            message: resData.errorMessage,
          };
          let command = resData.command;
          if (this.testmode === "test") {
            console.log("COMMAND:", command, resData);
          }
          // console.log("COMMAND:" + command);
          // if (command === "content" || command === "paperBlockLock") {
          //   console.log(message.body);
          // }
          if (command === "paperInfo") {
            let updateToken = resData.data.updateToken;
            if (
              updateToken &&
              this.boardUtil.findUpdateToken(updateToken) != -1
            ) {
              /* 전파자가 보낸신호는 되받지 않음 */
              this.boardUtil.removeUpdateToken(updateToken);
              // console.log("PASS! SENDER MESSAGE");
              return;
            }
            this.setPaperInfo(resData.data.paperInfo);
          }

          for (let uid in this.transmitter.subscribers) {
            let subscriber = this.transmitter.subscribers[uid];
            if (subscriber.subscribe(command, resData.data, error)) {
              break;
            }
          }
        }
      );
    },

    setPaperInfo(paperInfo) {
      for (let key in paperInfo) {
        this.paperInfo[key] = paperInfo[key];
      }
      if (paperInfo.startDay && paperInfo.startDay.length >= 8) {
        this.startDay = this.$moment(paperInfo.startDay).format("YYYY-MM-DD");
      }
      if (paperInfo.endDay && paperInfo.endDay.length >= 8) {
        this.endDay = this.$moment(paperInfo.endDay).format("YYYY-MM-DD");
      }
      this.docGrade = paperInfo.docGrade;
      this.projectCount = paperInfo.paperLinkProjectCount || 0;
      this.paperLockYn = String(paperInfo.lockYn);
      this.superiorMgrYn = String(paperInfo.superiorMgrYn);
      this.paperStatus = paperInfo.paperStatus;
      this.lastUpdInfo.lastUpdUserName = paperInfo.lastUpdUserName;
      this.lastUpdInfo.lastUpdUserNameEn = paperInfo.lastUpdUserNameEn;
      this.paperBookmarkId = paperInfo.paperBookmarkId;
      let lastUpdDate = paperInfo.lastUpdDate;
      this.lastUpdInfo.lastUpdDate = lastUpdDate;
    },
    setUserInfo(userInfo) {
      for (let key in userInfo) {
        this.userInfo[key] = userInfo[key];
      }
    },
    initCategoryList() {
      let url = "/api/copaper/category/getBoardCategoryItemList";
      let param = {
        paperId: this.paperInfo.paperId,
        paperProjectLinkId: this.$route.params.paperProjectLinkId,
      };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("getBoardCategoryItemList error", res.data.errorCode);
            // return;
          }
          obj.category.categoryList = res.data.result.categoryList;
          obj.category.selectedCategory = res.data.result.selectedCategory;
          obj.projectInfo = res.data.result.projectInfo;

          /* 보드 분류가 정해지지 않고 프로젝트정보가 없다면 프라이빗 보드로 분류 */
          if (
            obj.boardSection[0] == null &&
            (obj.projectInfo == null || obj.projectInfo.projectId == null)
          ) {
            obj.boardSection.splice(0, 1, "PRIV");
          }
          /* 의사결정 영역에 데이터 전달 */
          EventBus.$emit("updatePaperCommand", {
            command: "FOLDER",
            folderInfo: obj.category.selectedCategory,
          });

          obj.initPaperUserList();
        })
        .catch((err) => {
          console.log("axios err => ", err);
          setTimeout(location.reload, 1000);
        });
    },
    changeCategory(data) {
      let url = "/api/copaper/paper/updatePaperCategory";
      let param = {
        paperId: this.paperInfo.paperId,
        groupId: this.paperInfo.groupId,
        categoryMid: data.categoryMid,
        paperProjectLinkId: this.$route.params.paperProjectLinkId,
      };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode != null && res.data.errorCode != undefined) {
            if (res.data.errorCode == "SAVE_FAIL_ALREADY_EXISTS") {
              obj.toastInfo.message = obj.$i18nUtil.trans("message.BoardContent.010","이미 링크된 과제입니다.");
              obj.showToast(obj.toastInfo);
            } else if (
              res.data.errorCode == "SAVE_FAIL_PAPER_CATEGORY_MID_REQUIRED"
            ) {
              obj.toastInfo.message = obj.$i18nUtil.trans("TB089.001");
              obj.showToast(obj.toastInfo);
            } else if (res.data.errorCode == "SAVE_FAIL_SAME_CATEGORY_MID") {
              obj.toastInfo.message =
                this.$i18nUtil.trans("TB089.002");
              obj.showToast(obj.toastInfo);
            }
            return;
          }

          obj.toastInfo.message = obj.$i18nUtil.trans("TB002", {
            groupName:
              obj.projectInfo == null
                ? obj.$i18nUtil.trans("entity.cogroup.groupKbn.user","프라이빗")
                : obj.projectInfo.projectName,
            categoryName: data.categoryName,
          });
          obj.showToast(obj.toastInfo);
          obj.category.selectedCategory = data;
          /* 의사결정 영역에 데이터 전달 */
          EventBus.$emit("updatePaperCommand", {
            command: "FOLDER",
            folderInfo: obj.category.selectedCategory,
          });
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 업무보드 상태변경 */
    changePaperStatus(paperStatus) {
      let url = "/api/copaper/paper/updatePaperStatus";
      let param = {
        paperId: this.paperInfo.paperId,
        paperStatus: paperStatus,
      };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("updatePaperStatus error", res.data.errorCode);
            // return;
          }
          let prevPaperStatusName = obj.$i18nUtil.trans(
            "entity.paper.paperStatus." + obj.paperInfo.paperStatus.toUpperCase()
          );
          let newPaperStatusName = obj.$i18nUtil.trans(
            "entity.paper.paperStatus." + paperStatus.toUpperCase()
          );
          obj.toastInfo.message = obj.$i18nUtil.trans("TB001", {
            statusNameOld: prevPaperStatusName,
            statusNameNew: newPaperStatusName,
          });

          obj.showToast(obj.toastInfo);
          obj.paperStatus = paperStatus;
          obj.paperInfo.paperStatus = paperStatus;
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 업무보드 상태변경 */
    changePaperPeriod(periodJson) {
      let obj = this;
      let startDay =
        periodJson.startDay == ""
          ? ""
          : obj.$moment(periodJson.startDay).format("YYYY-MM-DD");
      let endDay =
        periodJson.endDay == ""
          ? ""
          : obj.$moment(periodJson.endDay).format("YYYY-MM-DD");
      if (periodJson.targetId == "startDay") {
        if (startDay != "" && endDay == "") {
          endDay = startDay;
        }
        if (startDay > endDay) {
          endDay = startDay;
        }
      } else {
        if (endDay != "" && startDay == "") {
          startDay = endDay;
        }
        if (startDay > endDay) {
          startDay = endDay;
        }
      }
      let url = "/api/copaper/paper/updatePaperPeriod";
      let param = {
        paperId: obj.paperInfo.paperId,
        startDay: startDay,
        endDay: endDay,
      };

      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("updatePaperPeriod error", res.data.errorCode);
            // return;
          }

          // obj.toastInfo.message = obj.$i18nUtil.trans("TB001", {
          //   statusNameOld: prevPaperStatusName,
          //   statusNameNew: newPaperStatusName,
          // });

          // obj.showToast(obj.toastInfo);
          // obj.paperStatus = paperStatus;
          // obj.paperInfo.paperStatus = paperStatus;
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 업로드 대상 파일 data set */
    setUploadData(data) {
      this.files = data;
    },
    /* 팝업에서 실행된 함수 완료 후 호출할 함수 */
    onSubmit(items) {
      console.log(items);
    },
    /* call upload */
    fileUpload(rtnData, fileElem) {
      let self = this;
      let editor = this.$refs.boardEditor;
      let util = this.boardUtil;
      // let elem = rtnData.data.obj;
      let sortNo = rtnData.data.sortNo;
      let fileName = this.files[0].fileName
        ? this.files[0].fileName
        : this.files[0].name;
      let fileType = util.fileExt(fileName);
      let res = [];
      self.HW_KEYGEN({ head: "BLOC", res });
      let paperBlockId = res[0];
      let formData = new FormData();
      let header = {
        "Content-Type": "multipart/form-data",
        Authorization: localStorage.getItem("Authorization"),
      };
      editor.blockContext.showProgress(60000);
      formData.append("file", this.files[0], fileName);
      formData.append("blockType", rtnData.data.uploadType); 
      /* tiptap editor image groupId */
      formData.append("groupId", String(this.paperInfo.groupId));
      formData.append("paperId", String(this.paperInfo.paperId));
      formData.append("paperBlockId", paperBlockId);
      formData.append(
        "sharepointSiteId",
        String(this.paperInfo.sharepointSiteId)
      );
      formData.append(
        "sharepointFolderId",
        String(this.paperInfo.sharepointFolderId)
      );
      if (this.projectInfo == null) {
        formData.append("projectId", null); // Noti 정보 보내기위해 추가 : 조성기
      } else {
        formData.append("projectId", String(this.projectInfo.projectId)); // Noti 정보 보내기위해 추가 : 조성기
      }

      let fncHideProgress = function () {
        if (fileElem) {
          fileElem.value = null;
        }
        editor.blockContext.hideProgress();
      };

      let fncFileUpload = function () {
        axios
          .post("/api/cofile/paper/registImage", formData, header)
          .then((res) => {
            // console.log("registImage success rtnData : ", rtnData);
            if (res.data.errorCode) {
              fncHideProgress();
              console.log(
                "ERR-CODE:" +
                  res.data.errorCode +
                  " / MESSAGE:" +
                  res.data.errorMessage
              );
              if (res.data.errorCode === "COFILE_COGROUP_INFO_EMPTY") {
                alert(self.$i18nUtil.trans("message.BoardContents.020","사이트 생성중.."));
                throw res.data.errorCode;
                return;
              } else if (res.data.errorCode === "COFILE_DLP_ERROR") {
                /*let errorMessage = JSON.parse(res.data.errorMessage);
                let message = errorMessage.detectedMessage;
                let modalHeight = 180;

                if (errorMessage.detectedFiles.length > 0) {
                  let detectedFiles = errorMessage.detectedFiles;
                  if (detectedFiles[0].data.length > 0) {
                    let detectedFilesData = detectedFiles[0].data;
                    for (let i = 0; i < detectedFilesData.length; i++) {
                      message += "\n";
                      message +=
                        "\n- 분 류 : " +
                        detectedFilesData[i].pattern +
                        " ( " +
                        detectedFilesData[i].count +
                        " 건 ) ";
                      message += "\n- 내 용 : " + detectedFilesData[i].content;
                      modalHeight += 60;
                    }
                  }
                }

                modalHeight = modalHeight + "px";
                self.showAlertDialog(message, null, {
                  width: "600px",
                  height: modalHeight,
                });*/

                // 2023-06-20 검출 건수 표시 및 공통 함수로 처리
                //self.showAlertDialog(self.$i18nUtil.trans("AB076"));
                util.makeDLPErrorMsg(self, res.data.errorMessage);
                throw res.data.errorCode;
                return;
              } else if (
                res.data.errorCode === "COFILE_STORAGE_CAPACITY_EXCEEDED"
              ) {
                self.showAlertDialog(
                  self.$i18nUtil.trans("AB054", { groupKbn: res.data.errorMessage })
                );
                throw res.data.errorCode;
                return;
              } else if (res.data.errorCode === "COFILE_FILE_UPLOAD_DENIED") {
                self.showAlertDialog(self.$i18nUtil.trans("AB069"));
                throw res.data.errorCode;
                return;
              } else if (res.data.errorCode === "COFILE_FILE_UPLOAD_CAPACITY_EXCEEDED") {
                self.showAlertDialog( self.$i18nUtil.trans("AB108",{ limitSize: res.data.errorMessage /1024 /1024 }));
                throw res.data.errorCode;
                return;
              } else if (res.data.errorCode === "COFILE_FILE_UPLOAD_FAIL") {
                self.showAlertDialog(self.$i18nUtil.trans("AB070"));
                throw res.data.errorCode;
                return;
              } else if (
                res.data.errorCode === "COFILE_FILE_UPLOAD_DENIED_FROM_EXTERNAL"
              ) {
                self.showAlertDialog(self.$i18nUtil.trans("AB100"));
                throw res.data.errorCode;
                return;
              }
            }
            fncHideProgress();

            let fileInfo = res.data.result.fileInfo;
            console.log("FILE-INFO:", fileInfo, paperBlockId);
            // 외부망에서 NAS에 파일 업로드할 경우(FILE_TYPE이 NAS일 경우) CDR 모듈을 거쳐야 하므로 바로 블록 업데이트 하지 않고
            // registImage API에서 블록 업데이트 Internal API 호출
            /*if (fileInfo.fileType === "NAS") {
              let bdata = editor.paperBlockMap[paperBlockId].bdata;
              let param = {
                uri: "/block/updateBlock",
                param: {
                  paperId: bdata.paperId,
                  paperBlockId: bdata.paperBlockId,
                  blockType: bdata.blockType,
                  sortNo: bdata.sortNo,
                  blockState: "0",
                  fileId: fileInfo.fileId,
                  content: bdata.contentPath,
                },
              };
              util.apiCall(param);
              bdata.blockState = 0;
              bdata.fileId = fileInfo.fileId;
            }*/
          })
          .catch(function (err) {
            console.log("파일 업로드 실패", err);
            fncHideProgress();
            let bdata = editor.paperBlockMap[paperBlockId].bdata;
            util.removeBlockData(paperBlockId);
            let param = {
              uri: "/block/deleteBlock",
              param: {
                paperId: bdata.paperId,
                groupId: self.paperInfo.groupId,
                paperBlockId: paperBlockId,
              },
            };
            util.apiCall(param);
            let toastMsg = "";
            toastMsg = self.$i18nUtil.trans("TB102"); // 파일 업로드가 실패하였습니다.
            if (toastMsg) {
              let toastInfo = {
                obj: self.$toasted,
                message: toastMsg,
                options: {
                  theme: "toasted-primary",
                  position: "bottom-left",
                  duration: 3000,
                },
              };
              self.showToast(toastInfo);
            }
          });
      };
      if (rtnData.data.uploadType == editor.BTPS().IMAGELINK) {
        util.createTempBlock(
          {
            blockType: editor.BTPS().IMAGELINK,
            paperBlockId: paperBlockId,
            content: this.files[0].name,
            blockState: 1,
            sortNo: sortNo,
          },
          fncFileUpload
        );
      } else if (fileType[1] === util.fileTypes.IMAGE) {
        util.createTempBlock(
          {
            blockType: editor.BTPS().IMAGE,
            paperBlockId: paperBlockId,
            content: this.files[0].name,
            blockState: 1,
            sortNo: sortNo,
          },
          fncFileUpload
        );
      } else {
        util.createTempBlock(
          {
            blockType: editor.BTPS().FILE,
            paperBlockId: paperBlockId,
            content: this.files[0].name,
            blockState: 1,
            sortNo: sortNo,
          },
          fncFileUpload
        );
      }
      if (rtnData.onCreate) {
        rtnData.onCreate(paperBlockId);
      }
    },
    onAddPaperUserWithOrg() {
      //조직도
      const modalInfo = {
        title: this.$i18nUtil.trans("title.MultiOrg.001","조직도"),
        method: "post",
        width: "1050px",
        height: "800px",
        obj: this.$modal,
        //orgType: "SINGLE_USER",
        //orgType: "MULTI_USER",
        orgType: "MULTI_ORG_BOARD",
        //orgType: "SINGLE_DEPT",
        //orgType: "MULTI_DEPT",
        //component: Organization,
        component: MultiOrg,
        paperId: this.paperInfo.paperId,
        url: "/api/org/getDeptList",
      };
      this.showModal(modalInfo);
    },
    /* 협업멤버 선택 */
    selectBoardUser(data, index) {
      if (index < 0) {
        return;
      }
      let modalInfo = {};
      // if (th) {
      // modalInfo = {
      //     title: "멤버 추가",
      //     width: "400px",
      //     height: "166px",
      //     obj: this.$modal,
      //     contents: "운영자만 접근권한이 있습니다.",
      //     button: "확인",
      //     component: Dialog,
      //   };
      // } else {

      modalInfo = {
        title: this.$i18nUtil.trans("title.dialog.add.member","멤버 추가"),
        width: "400px",
        // height: "166px",
        obj: this.$modal,
        contents: this.$i18nUtil.trans("message.dialog.add.member","멤버로 추가하시겠습니까?"),
        button: this.$i18nUtil.trans("button.dialog.add","추가"),
        subButton: this.$i18nUtil.trans("button.dialog.cancel","취소"),
        userId: data.userId,
        dialogType: "ADD_MEMBER",
        component: Dialog,
      };
      // }

      this.showModal(modalInfo);

      // }
    },
    rejectBoardMember(paperUserItem, dialogType) {
      let contents = "";
      let button = "";
      if (dialogType == "SELF_REJECT") {
        let managerYn = 0;
        if (paperUserItem.userGrade == "MANAGER") {
          for (let i = 0; i < this.userList.length; i++) {
            if (this.userList[i].userGrade == "MANAGER") {
              managerYn++;
            }
          }
          //운영자는 최소 1명이어야 함.
          if (managerYn == 1) {
            const modalInfo = {
              title: this.$i18nUtil.trans("title.dialog.notice","알림"), 
              width: "400px",
              // height: "166px",
              obj: this.$modal,
              contents: this.$i18nUtil.trans("AB064"),
              button: this.$i18nUtil.trans("button.confirm","확인"), 
              component: Dialog,
            };
            this.showModal(modalInfo);
            return;
          }
        }
        button = this.$i18nUtil.trans("button.resign","탈퇴");
        contents = this.$i18nUtil.trans("AB019", {
          targetName: this.paperInfo.paperTitle,
        });
      } else {
        button = this.$i18nUtil.trans("button.except","제외");
        contents = this.$i18nUtil.trans("AB020", {
          userName: paperUserItem.userName,
          targetName: this.paperInfo.paperTitle,
        });
      }
      const modalInfo = {
        title: this.$i18nUtil.trans("title.Noti.001","알림"),
        width: "400px",
        // height: "166px",
        obj: this.$modal,
        contents: contents,
        button: button,
        subButton: this.$i18nUtil.trans("button.cancel","취소"),
        paperUserItem: paperUserItem,
        dialogType: dialogType,
        component: Dialog,
      };
      this.showModal(modalInfo);
    },
    /* 멤버삭제 dialog 확인버튼 */
    dialogConfirm(modalInfo) {
      if (!modalInfo.dialogType) {
        return;
      }
      if (modalInfo.dialogType == "ADD_MEMBER") {
        const obj = this;
        let addUserList = [];
        let addJson = {};
        addJson.userGrade = "MEMBER";
        addJson.userKbn = "01";
        addJson.paperUserId = modalInfo.userId;
        addUserList.push(addJson);
        let url = "/api/copaper/paperuser/registPaperUser";
        let param = {
          paperId: this.paperInfo.paperId,
          addPaperUserList: addUserList,
        };
        axios
          .post(url, param)
          .then((res) => {
            if (res.data.errorCode) {
            } else {
              if (
                res.data.result.policyBlockUserList &&
                res.data.result.policyBlockUserList.length > 0
              ) {
                obj.toastInfo.message = obj.$i18nUtil.trans("message.MemberCallSearch.006","정보교류차단 지침에 따라 멤버 초대가 불가능한 사용자입니다.");
                obj.showToast(obj.toastInfo);
                return;
              } else if(res.data.result.checkPolicy && res.data.result.checkPolicy.length >0 ){
                let checkPolicy = "";
                res.data.result.checkPolicy.forEach((res)=>{
                  checkPolicy += ("- " + res.chineseWallPolicyName + "\n");
                })
                obj.showAlertDialog(obj.$i18nUtil.trans("AB113",{ checkPolicy: checkPolicy}));
                return;
              }

              obj.initPaperUserList();
              obj.toastInfo.message = obj.$i18nUtil.trans("TB080");
              obj.showToast(obj.toastInfo);
            }
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });
      }else if(modalInfo.dialogType == "ORG_ADD_MEMBER"){// 보드 조직도에서 추가
        const obj = this;
        let addUserList = [];
        
        modalInfo.users.forEach(user => {
          let addJson = {};
          addJson.userGrade = "MEMBER";
          addJson.userKbn = "01";
          addJson.paperUserId = user.userId;
          addUserList.push(addJson);
				});
        let url = "/api/copaper/paperuser/registPaperUser";
        let param = {
          paperId: this.paperInfo.paperId,
          addPaperUserList: addUserList,
        };
        axios
          .post(url, param)
          .then((res) => {
            if (res.data.errorCode) {
            } else {
              if (
                res.data.result.policyBlockUserList &&
                res.data.result.policyBlockUserList.length > 0
              ) {
                obj.toastInfo.message = obj.$i18nUtil.trans("message.MemberCallSearch.006","정보교류차단 지침에 따라 멤버 초대가 불가능한 사용자입니다.");
                obj.showToast(obj.toastInfo);
                return;
              } else if(res.data.result.checkPolicy && res.data.result.checkPolicy.length >0 ){
                let checkPolicy = "";
                res.data.result.checkPolicy.forEach((res)=>{
                  checkPolicy += ("- " + res.chineseWallPolicyName + "\n");
                })
                obj.showAlertDialog(obj.$i18nUtil.trans("AB113",{ checkPolicy: checkPolicy}));
                return;
              }

              obj.initPaperUserList();
              obj.toastInfo.message = obj.$i18nUtil.trans("TB080");
              obj.showToast(obj.toastInfo);
            }
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });
      } else {
        let url = "/api/copaper/paperuser/deletePaperUser";
        let param = {};
        let managerYn = 0;
        if (modalInfo.dialogType == "SELF_REJECT") {
          // if (modalInfo.paperUserItem.userGrade == "MANAGER") {
          //   for (let i = 0; i < this.userList.length; i++) {
          //     if (this.userList[i].userGrade == "MANAGER") {
          //       managerYn++;
          //     }
          //   }
          //   //운영자는 최소 1명이어야 함.
          //   if (managerYn == 1) {
          //     const modalInfo = {
          //       title: "알림",
          //       width: "400px",
          //       height: "166px",
          //       obj: this.$modal,
          //       contents: "더이상 운영자가 없습니다.",
          //       button: "확인",
          //       component: Dialog,
          //     };
          //     this.showModal(modalInfo);
          //     return;
          //   }
          // }
          param = {
            paperId: this.paperInfo.paperId,
          };
        } else {
          param = {
            paperId: this.paperInfo.paperId,
            userId: modalInfo.paperUserItem.userId,
          };
        }
        let obj = this;
        axios
          .post(url, param)
          .then((res) => {
            if (res.data.errorCode) {
            } else {
              if (modalInfo.dialogType == "SELF_REJECT") {
                obj.toastInfo.message = obj.$i18nUtil.trans("TB025", {
                  targetName: obj.$i18nUtil.trans("message.BoardContents.021","보드"), //obj.paperInfo.paperTitle,
                });
                obj.showToast(obj.toastInfo);
                if (obj.boardSection[0] == null) {
                  //과제
                  obj.$router.replace(
                    "/general/dashboard/" + obj.projectInfo.projectId
                  );
                } else if (obj.boardSection[0] == "PRIV") {
                  //프라이빗
                  obj.$router.replace("/general/myPage");
                } else if (obj.boardSection[0] == "CFRC") {
                  // 카테고리
                  obj.$router.replace("/general/cooperation");
                } else if (obj.boardSection[0] == "SHAR") {
                  // 카테고리
                  obj.$router.replace("/general/shareInfo");
                } else {
                  // 속한 보드 없음
                  obj.$router.replace("/general/home");
                }
              }
              obj.initPaperUserList();
            }
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });
      }
    },
    initPaperUserList() {
      let url = "/api/copaper/paperuser/getPaperUserList";
      let param = { paperId: this.paperInfo.paperId };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("getPaperUserList error", res.data.errorCode);
            // return;
          }
          // obj.userList =
          //   res.data.result.userList != null ? res.data.result.userList : [];

          let list = res.data.result != null && res.data.result.userList != null ? res.data.result.userList : [];
          list.forEach(user => {
            if(obj.$i18nUtil.getLanguage() === 'ko') {

            }else{
              user.userName = user.userNameEn != null ? user.userNameEn : user.userName;
              user.deptName = user.deptNameEn != null ? user.deptNameEn : user.deptName;
              user.companyName = user.companyNameEn != null ? user.companyNameEn : user.companyName;
              user.jobPositionName = user.jobPositionNameEn != null ? user.jobPositionNameEn : user.jobPositionName;
              user.jobFunctionName = user.jobFunctionNameEn != null ? user.jobFunctionNameEn : user.jobFunctionName;
            }
          })

          obj.userList = list || [];

          obj.paperUserCount = res.data.result.countuser;
          obj.inherit = res.data.result.inherit;
          obj.currentGrade = res.data.result.grade;
          obj.isInternalUser = res.data.result.isInternalUser;
          /* 모든 하위모듈에서 재사용 가능하도록 데이터 저장 */
          if (res.data.result) {
            let data = res.data.result;
            let info = obj.boardMemberInfo;
            info.countuser = data.countuser;
            info.inherit = data.inherit;
            info.userId = data.userId;
            if (info.userList) {
              info.userList.splice(0, info.userList.length);
            } else {
              info.userList = [];
            }

            if (info.paperUser) {
              info.paperUser.splice(0, info.paperUser.length);
            } else {
              info.paperUser = [];
            }

            if (info.projectUser) {
              info.projectUser.splice(0, info.projectUser.length);
            } else {
              info.projectUser = [];
            }

            if (data.userList) {
              data.userList.forEach((e, inx) => {
                info.userList.splice(inx, 0, e);
              });
            }
            if (data.paperUser) {
              data.paperUser.forEach((e, inx) => {
                info.paperUser.splice(inx, 0, e);
              });
            }
            if (data.projectUser) {
              data.projectUser.forEach((e, inx) => {
                info.projectUser.splice(inx, 0, e);
              });
            }
            /* At 사용시 null 오류방지용 */
            info.userList.forEach((e) => {
              if (!e.userName) {
                e.userName = "";
              }
            });
            /* 의사결정 영역에 데이터 전달 */
            EventBus.$emit("updatePaperCommand", {
              command: "MEMBER",
              userListCount: obj.paperUserCount,
            });
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
          setTimeout(location.reload, 1000);
        });
    },
    //이미 멤버일시 멤버 추가버튼 x
    memberCheck(userId) {
      let isMember = true;
      this.userList.forEach((value) => {
        if (value.userId == userId) {
          isMember = false;
        }
      });
      return isMember;
    },
    toggleBookmark() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        paperId: obj.paperInfo.paperId,
        bookmarkId: obj.paperBookmarkId,
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/bookmark/savePaperBookmark";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          obj.paperBookmarkId = res.result;
          if (obj.paperBookmarkId != null) {
            obj.toastInfo.message = obj.$i18nUtil.trans("TB041");
            obj.showToast(obj.toastInfo);
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("TB042");
            obj.showToast(obj.toastInfo);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    toggleInfoSharePaperLike() {
      let obj = this;
      let reqData = {};
      reqData.params = {
        paperId: obj.paperInfo.paperId,
      };
      reqData.req = obj.req;
      reqData.url = "/api/copaper/infoshare/setPaperLike";
      reqData.method = "post";
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode != null) {
          } else {
            obj.paperLikeCount = res.result.paperLikeCount;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    closeBoardLeftModal(leftModalData) {
      this.$parent.$children[0].refresh();
    },
    openBoardHistoryModal() {
      const modalInfo = {
        title: this.$i18nUtil.trans("message.BoardContents.022","활동내역"),
        width: "100%",
        height: "100%",
        obj: this.$modal,
        paperInfo: this.paperInfo,
        boardUtil: this.boardUtil,
        userInfo: this.userInfo,
        component: BoardHistory,
      };
      let hwWrapDiv = this.$root.$el.querySelector("div.hw_wrap");
      if (hwWrapDiv && hwWrapDiv != null) {
        if (!hwWrapDiv.classList.contains("overflowhidden")) {
          hwWrapDiv.classList.add("overflowhidden");
        }
      }
      this.showModal(modalInfo);
      // this.showBoardHistory = true;
    },
    closeBoardHistoryModal() {
      this.showBoardHistory = false;
    },
    /* 업무보드 복제 */
    copyPaperModal(board,copy) {
      let obj = this;
      let modalHeight = null;
      let copyComponent = CopyBoardModal;
      let boardCopy = obj.tenantId === '201' && obj.boardSection[0] === "SHAR" ? true : false;
      let hoToBoard = false;
      if(copy && boardCopy){
        hoToBoard = true;
      }
      
      if (board.categoryInfo) {
        if (
          board.categoryInfo.section != null &&
          board.categoryInfo.section == "SHAR" && !hoToBoard
        ) {
          
          copyComponent = CopyInfoShareBoardModal;
          modalHeight = "300px";
          const modalInfo = {
            title: this.$i18nUtil.trans("title.CopyBoardModal.001","업무보드 복제"),
            name: "copyBoardModal",
            method: "post",
            width: "800px",
            height: modalHeight,
            obj: this.$modal,
            paperId: board.paperId,
            groupId: board.groupId,
            component: copyComponent,
          };
          this.showModal(modalInfo);
        } else if (
          board.categoryInfo.section != null &&
          board.categoryInfo.section == "CFRC" && !hoToBoard
        ) {
          
          copyComponent = CopyCooperationBoardModal;
          modalHeight = "404px";
          const modalInfo = {
            title: this.$i18nUtil.trans("title.CopyBoardModal.001","업무보드 복제"),
            name: "copyBoardModal",
            method: "post",
            width: "800px",
            height: modalHeight,
            obj: this.$modal,
            paperId: board.paperId,
            groupId: board.groupId,
            component: copyComponent,
          };
          this.showModal(modalInfo);
        } else {
          
          const modalInfo = {
            title: this.$i18nUtil.trans("title.CopyBoardModal.001","업무보드 복제"),
            name: "copyBoardModal",
            method: "post",
            width: "800px",
            obj: this.$modal,
            paperId: board.paperId,
            groupId: board.groupId,
            component: copyComponent,
            hoToBoard:hoToBoard
          };
          this.showModal(modalInfo);
        }
      }
    },
    boardMemberSearch(_event) {
      if (_event) {
        this.searchMemberInput = _event.target.value;
      }
      if (this.searchMemberInput.length > 1) {
        this.searchMemberList = [];
        this.searchNoMemberList = [];
        this.isMemberSearch = true;
        let url = "/api/auth/org/searchByUserName";
        let param = {
          searchKeyword: this.searchMemberInput,
        };
        let obj = this;
        axios
          .post(url, param)
          .then((res) => {
            obj.searchUserList = res.data.result;
            obj.searchUserList.forEach((item) => {
              let isMember = false;
              obj.userList.forEach((value) => {
                if (item.userId == value.userId) {
                  isMember = true;
                }
              });
              if (isMember) {
                obj.searchMemberList.push(item);
              } else {
                obj.searchNoMemberList.push(item);
              }
            });
          })
          .catch((err) => {
            console.log("axios err => ", err);
          });
      } else {
        this.boardMemberSearchClose();
      }
    },
    clickMemberSearchBtn() {
      if (this.searchMemberInput.length > 0) {
        this.isMemberSearch = false;
        this.searchMemberInput = "";
      }
    },
    boardMemberSearchClose() {
      this.isMemberSearch = false;
      this.searchUserList = [];
    },
    /* 멤버 검색시 가입중 여부 확인 */
    joinCheck(userId) {
      for (let i = 0; i < this.userList.length; i++) {
        if (userId == this.userList[i].userId) {
          return true;
        } else {
          continue;
        }
      }
      return false;
    },
    memberCount(count) {
      let resultCount = count;
      this.userList.forEach((element) => {
        if (element.userId == this.userInfo.userId) {
          resultCount = count - 1;
        }
      });
      return resultCount;
    },
    /* 알림 차단 */
    setNotiExceptTarget() {
      event.target.classList.toggle("active");
      let url = "/api/noti/setNotiExceptTarget";
      let param = {
        targetId: this.paperInfo.paperId,
        targetKbn: "paperId",
      };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.result == null) {
            //알림 설정 [TB039]
            this.notiExceptTarget = res.result;
            obj.toastInfo.message = obj.$i18nUtil.trans("TB039"); // 알림 설정 시 보드 업데이트 내용이 전달됩니다.
            obj.showToast(obj.toastInfo);
          } else {
            //알림 차단 [TB040]
            this.notiExceptTarget = res.result;
            obj.toastInfo.message = obj.$i18nUtil.trans("TB040"); // 알림 해제 시 보드 업데이트 내용이 전달되지 않습니다.
            obj.showToast(obj.toastInfo);
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    getNotiExceptTarget() {
      let url = "/api/noti/getNotiExceptTarget";
      let param = {
        targetId: this.paperInfo.paperId,
      };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          this.notiExceptTarget = res.data.result;
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    closeBoardLinkProjectModal(count) {
      this.projectCount = count;
    },
    setGroupPublicYn(groupInfo) {
      let obj = this;
      /*
        프라이빗 : USER
        - 보드 : SECRET(비공개) PAPER_USER O

        과제 : PRO
        - 과제공개여부 : 전체
          보드 : NORMAL(전체공개) COGROUP_USER O, RESTRICT(멤버만 공개) COGROUP_USER O, SECRET(비공개) PAPER_USER O
        - 과제공개여부 : 멤버만 공개
          보드 : RESTRICT(멤버만 공개) COGROUP_USER O, SECRET(비공개) PAPER_USER O

        정보공유 : SHAR
        - 카테고리 공개여부 : 전체
          보드 : SECRET(전체공개)
        - 카테고리 공개여부 : 멤버만 공개
          보드 : RESTRICT(멤버만 공개) CATEGORY_USER O, SECRET(비공개) PAPER_USER O

        회의협의 : CFRC
        - 카테고리 공개여부 : 전체
          보드 : NORMAL(전체공개) CATEGORY_USER O, RESTRICT(멤버만 공개) CATEGORY_USER O, SECRET(비공개) PAPER_USER O
        - 카테고리 공개여부 : 멤버만 공개
          보드 : RESTRICT(멤버만 공개) CATEGORY_USER O, SECRET(비공개) PAPER_USER O
      */
      if (groupInfo.groupKbn == "CFRC" || groupInfo.groupKbn == "SHAR") {
        obj.publicYn = 1;
        // 회의협의 경우 보드가 전체공개이면 멤버만공개로 선택되도록 처리..
        if (obj.paperInfo.docGrade != "NORMAL") {
          obj.publicYn = 0;
        }
        if (
          obj.paperInfo.categoryInfo != null &&
          obj.paperInfo.categoryInfo.docGrade != "NORMAL"
        ) {
          obj.publicYn = 0;
          if (obj.paperInfo.docGrade == "NORMAL") {
            obj.paperInfo.docGrade = "RESTRICT";
            obj.docGrade = obj.paperInfo.docGrade;
          }
        }
      } else {
        if (groupInfo.groupKbn == "PRO" && groupInfo.publicYn != 1) {
          if (obj.paperInfo.docGrade == "NORMAL") {
            obj.paperInfo.docGrade = "RESTRICT";
            obj.docGrade = obj.paperInfo.docGrade;
          }
        }
        obj.publicYn = groupInfo.publicYn;
        // if (obj.paperInfo.docGrade != "NORMAL") {
        //   obj.publicYn = 0;
        // }
      }
    },
    // 2021-03-04 okr사용여부 조회 추가
    // 2021-03-22 okr사용여부 localStorage.getItem("okrUse")로 변경(특정 사용자 제외 로직 추가로 인함.)
    // 2021-04-22 정보공유 회의협의체 보드일떄 okr 숨김.
    checkOkrUse(groupKbn) {
      let obj = this;
      if (localStorage.getItem("okrUse") == "false") {
        obj.okrUseFlag = false;
      } else {
        obj.okrUseFlag = true;
        if (groupKbn == "PRO") {
          setTimeout(() => {
          obj.getBoardKrQrtList();
          }, 500);
        }else if(groupKbn =="CFRC" || groupKbn =="SHAR"){
          obj.okrUseFlag = false;
        }
      }
    },
    /* 보드 OKR 분기/KR 리스트 조회 */
    getBoardKrQrtList() {
      let url = "/api/copaper/okr/getPaperQrtList";
      let param = {
        paperId: this.paperInfo.paperId,
      };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("getPaperQrtList error", res.data.errorCode);
            // return;
          }
          let list = res.data.result.qrtList;
          obj.qrtList = list;
          obj.paperKrLinkList = res.data.result.paperKrLinkList;
          obj.paperKrLinkCount = res.data.result.paperKrLinkCount;
          let currQrtCheck = false;
          for (let i = 0; i < obj.qrtList.length; i++) {
            if (obj.qrtList[i].CURR_QRT_YN == 1) {
              currQrtCheck = true;
              obj.currentQrt.qrtCd = obj.qrtList[i].QRT_CD;
              obj.currentQrt.qrtTopMsg = obj.qrtList[i].QRT_TOP_MSG;
              obj.currentQrt.qrtTopMsgEn = obj.qrtList[i].QRT_TOP_MSG_EN;
              break;
            }
          }
          if (!currQrtCheck && obj.qrtList.length > 0) {
            obj.currentQrt.qrtCd = obj.qrtList[0].QRT_CD;
            obj.currentQrt.qrtTopMsg = obj.qrtList[0].QRT_TOP_MSG;
            obj.currentQrt.qrtTopMsgEn = obj.qrtList[0].QRT_TOP_MSG_EN;
          }
          if (obj.qrtList == null || obj.qrtList.length == 0) {
            obj.paperKrLinkCount = 0;
            obj.paperKrLinkList = [];
          }
        })
        .catch((err) => {
          console.log("getPaperQrtList axios error", err);
          //obj.showAlertDialog('OKR 연동에 실패했습니다.');
        });
    },
    qrtChange(qrtCd, event) {
      this.currentQrt.qrtCd = qrtCd;
      this.currentQrt.qrtTopMsg = event.target.innerText;
      this.getBoardKrListByQrtCd(qrtCd);
    },
    /* 보드 OKR 분기/KR 리스트 조회 */
    getBoardKrListByQrtCd(qrtCd) {
      let url = "/api/copaper/okr/getPaperOkrList";
      let param = {
        paperId: this.paperInfo.paperId,
        qrtCd: qrtCd,
      };
      let obj = this;
      axios
        .post(url, param)
        .then((res) => {
          if (res.data.errorCode) {
            console.log("getPaperOkrList error", res.data.errorCode);
            // return;
          }
          if (res.data.result != null || res.data.result != undefined) {
            obj.paperKrLinkList = res.data.result.paperKrLinkList;
            obj.paperKrLinkCount = res.data.result.paperKrLinkCount;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    changeOkrType(type) {
      let resultType = "";
      if (type == "MO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.MO","개인 O");
      } else if (type == "UO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.UO","유닛 O");
      } else if (type == "TO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.TO","팀 O");
      } else if (type == "HO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.HO","본부 O");
      } else if (type == "CO") {
        resultType = this.$i18nUtil.trans("message.project.OKR.CO","회사 O");
      } else if (type == "MK") {
        resultType = this.$i18nUtil.trans("message.project.OKR.MK","개인 KR");
      } else if (type == "UK") {
        resultType = this.$i18nUtil.trans("message.project.OKR.UK","유닛 KR");
      } else if (type == "TK") {
        resultType = this.$i18nUtil.trans("message.project.OKR.TK","팀 KR");
      } else if (type == "HK") {
        resultType = this.$i18nUtil.trans("message.project.OKR.HK","본부 KR");
      } else {
        resultType = this.$i18nUtil.trans("message.project.OKR.else","회사 KR");
      }
      return resultType;
    },
    /* KR 연결 모달 호출 */
    linkedOkrPopup() {
      const modalInfo = {
        title: this.$i18nUtil.trans("message.BoardContents.023","KR연결 추가"),
        width: "800px",
        // height: "743px",
        obj: this.$modal,
        paperId: this.paperInfo.paperId,
        paperTitle: this.paperInfo.paperTitle,
        type: this.boardSection[0],
        // startDate: this.startDate,
        // endDate: this.endDate,
        component: BoardLinkedOkr,
      };
      this.showModal(modalInfo);
    },
    okrDisconnection(id) {
      let obj = this;
      let url = "/api/copaper/okr/deletePaperOkrLink";
      let param = {
        paperId: obj.paperInfo.paperId,
        paperOkrLinkId: id,
        qrtCd: obj.currentQrt.qrtCd,
      };
      axios
        .post(url, param)
        .then((res) => {
          if (res.errorCode == null) {
            obj.paperKrLinkList = res.data.result.paperKrLinkList;
            obj.paperKrLinkCount = res.data.result.paperKrLinkCount;
            obj.toastInfo.message = obj.$i18nUtil.trans("TB081"); //  "연결이 해제되었습니다.";
            obj.showToast(obj.toastInfo);
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    closeBoardOkrLinkPopup() {
      this.getBoardKrQrtList();
    },
    /* 상위 탭 클릭 */
    changeTab(index) {
      let obj = this;
      if (index === 0) {
        // 업무보드 탭
        obj.paperAllComment(true);
        obj.$refs.boardEditor.reloadContentBlocks();
      } else if (index === 2) {
        // 할 일 탭
        obj.paperAllComment(false);
        if (obj.blockInfo.commentSelectId) {
          obj.blockInfo.commentSelectId = "";
        }
        obj.$refs.boardTodo.getUserInfo();
      } else if (index === 1) {
        // 파일 탭
        obj.paperAllComment(false);
        if (obj.blockInfo.commentSelectId) {
          obj.blockInfo.commentSelectId = "";
        }
        obj.$refs.boardFiles.getBoardFileList(true);
      }
      obj.currentTab = index;
      window.scrollTo(0, 0);
    },
    /* 파일 삭제 */
    deleteFile(_data) {
      let obj = this;
      let locationKbn = _data.locationKbn;
      let url = "/api/cofile/paper/deleteAttach";
      let param = {
        groupId: _data.groupId,
        fileId: _data.fileId,
      };
      axios
        .post(url, param)
        .then((res) => {
          let errorCode = res.data.errorCode;
          if (errorCode == null) {
            obj.$refs.boardFiles.getBoardFileList();
            if (locationKbn == "OUTPUT" || locationKbn == "DECISION") {
              EventBus.$emit("deleteOutputFile", _data.fileId);
            }
            obj.toastInfo.message = obj.$i18nUtil.trans("TB011"); // 파일이 삭제되었습니다.
            obj.showToast(obj.toastInfo);
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 할 일 레이어 팝업 */
    showTodo() {
      let hanwha = $(location).attr("origin");
      window.open(
        hanwha + "/general/todoBoardPopup/" + this.paperInfo.paperId,
        "_blank",
        "width=1264, height=800"
      );
    },
    searchReset() {
      this.isSearch = this.isSearch == true ? false : true;
      $("#searchInput").val("");
    },
    $dm(e, a) {
      return this.boardUtil.$dm(e, a);
    },
    updateTodoList(todoSelectedblockId) {
      // this.boardUtil.removeBlockData(todoSelectedblockId);
      let param = {
        uri: "/block/deleteBlock",
        param: {
          paperId: this.paperInfo.paperId,
          groupId: this.paperInfo.groupId,
          paperBlockId: todoSelectedblockId,
        },
      };
      this.boardUtil.apiCall(param);
    },
    /* 이모티콘 사용 여부 체크 */
    checkEmoticonUse() {
      let item = this.emoticonUse
      for(let key in item) {
        let location = this.$emoticonFn.getEmoticonLocation(key);
        this.$emoticonFn.checkEmoticonUse(location)
          .then(res => {
            this.emoticonUse[key] = res || false;
            // if(res) this.getEmoticonLocation(key, location);
            if(res && (this.emoticonItem === key)) this.getEmoticonLocation(key, location);
          });
      }
    },
    /* 이모티콘 목록 가져오기 */
    getEmoticonLocation(key, location) {
      !this.emoticonUse[key] ? [] :
        this.$emoticonFn.getEmoticonList(this.tenantId, location)
          .then(resp => {
            this.emoticonList[key] = resp
          }) 
    },
    /**
     * 호출 레이어: 멤버 외 사용자 검색 여부
     * 회사 임직원 전체 조회 searchNonMember === true
     * 속한 멤버 내에서 조회 searchNonMember === false
     */
    setSearchNonMember() {
      codeValueJs.getCodeValueList('tenant.env', 'mention.search.nonMember').then(res => {
        let codeValueList = res;
        this.searchNonMember 
          = (codeValueList.length > 0 && codeValueList[0].cdValue === 'false') ? false : true;
      });
    },
    // 자동번호매기기 기능 사용 여부
    checkOrderList(){
      let obj = this;
      let reqData = {};
      let cdValue = true;
      reqData.params = {
        tenantId:obj.tenantId,
        cdCategory: "tenant.env",
        cdKey: "board.orderList.use",
      };
      reqData.url = "/api/org/code/checkCodeValue";
      reqData.method = "post";

      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            if(res.result.cdValue != undefined){
              cdValue = res.result.cdValue;
            }
            localStorage.setItem("orderListUse", cdValue);
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    // 보드에서 조직도로 멤버추가 기능 사용 여부
    checkOrgMapUse(){
      let obj = this;
      let reqData = {};
      let cdValue = false;
      reqData.params = {
        tenantId:obj.tenantId,
        cdCategory: "tenant.env",
        cdKey: "board.org.use",
      };
      reqData.url = "/api/org/code/checkCodeValue";
      reqData.method = "post";

      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            if(res.result.cdValue != undefined){
              cdValue = res.result.cdValue;
            }
            localStorage.setItem("orgMapUse", cdValue);
            obj.orgMapUse = cdValue;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    // 보드에서 생성자 권한 이전 사용여부
    checkPermissionUse(){
      let obj = this;
      let reqData = {};
      let cdValue = false;
      reqData.params = {
        tenantId:obj.tenantId,
        cdCategory: "tenant.env",
        cdKey: "board.permission.use",
      };
      reqData.url = "/api/org/code/checkCodeValue";
      reqData.method = "post";

      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            if(res.result.cdValue != undefined){
              cdValue = res.result.cdValue;
            }
            localStorage.setItem("permissionUse", cdValue);
            obj.permissionUse = cdValue;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    // 생성자 권한 이전
    permissionAssignment(){
      let obj = this;
      const modalInfo = {
            title: this.$i18nUtil.trans("button.paper.permission.assignment","생성자 권한 이전"),
            name: "PaperPermissionModal",
            method: "post",
            width: "800px",
           // height: modalHeight,
            obj: this.$modal,
            userList: this.userList,
            userInfo: this.userInfo,
            paperInfo: this.paperInfo,
            inherit: this.inherit,
            isInternalUser: this.isInternalUser,
            docGrade: this.docGrade,
            //groupId: board.groupId,
            component: PaperPermissionModal,
          };
          this.showModal(modalInfo);
    },
  },
};
</script>
<style scoped>
#modals-container >>> .v--modal-overlay .v--modal-box {
  overflow: visible;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/base/BoardContent.vue